var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-hospital-building",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-hospital-building:not(.animated) .animable {opacity: 0;}svg#freepik_stories-hospital-building.animated #freepik--background-simple--inject-2 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-hospital-building.animated #freepik--Plants--inject-2 {animation: 6s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-hospital-building.animated #freepik--Clouds--inject-2 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-hospital-building.animated #freepik--Trees--inject-2 {animation: 6s Infinite  linear wind;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246.194px 271.824px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.76,327.31c-16,37.3-46.91,77-88.26,87.26C304,430,294.3,479.34,184.18,469.49a222.91,222.91,0,0,1-47.38-9.27,184.65,184.65,0,0,1-22.08-8.53c-63.22-29.17-94.11-88.23-94-148.49.08-79.25,57.05-114.32,93.95-134.68s84.2-103.83,192.53-95a216.18,216.18,0,0,1,48.7,9.5c36,11.62,72.12,35.24,92.16,68.22,1.51,2.47,2.93,5,4.29,7.58C478.85,209.17,476.56,276.45,454.76,327.31Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "246.194px 271.824px"
    },
    id: "elcxo92hgarxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5w7gggpwfte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.76,327.31c-16,37.3-46.91,77-88.26,87.26C304,430,294.3,479.34,184.18,469.49a222.91,222.91,0,0,1-47.38-9.27,184.65,184.65,0,0,1-22.08-8.53c-63.22-29.17-94.11-88.23-94-148.49.08-79.25,57.05-114.32,93.95-134.68s84.2-103.83,192.53-95a216.18,216.18,0,0,1,48.7,9.5c36,11.62,72.12,35.24,92.16,68.22,1.51,2.47,2.93,5,4.29,7.58C478.85,209.17,476.56,276.45,454.76,327.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "246.194px 271.824px"
    },
    className: "animable",
    id: "elwam8eak3xi"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "248.93px 440.24px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.43,440.74h-451a.5.5,0,0,1,0-1h451a.5.5,0,1,1,0,1Z",
    id: "elj1ln5k9i2s",
    className: "animable",
    style: {
      transformOrigin: "248.93px 440.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246.599px 424.957px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,418a8.78,8.78,0,0,0,2.58.29s-.39-1.2-.43-1.27c-.4-.84-1.67-2.23-2.7-2.09a1.22,1.22,0,0,0-1,1.54A2.56,2.56,0,0,0,32,418Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "32.4919px 416.608px"
    },
    id: "el50hpjgejey5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.66,423.3a8.6,8.6,0,0,0,2.54-.4,23.16,23.16,0,0,0,1,2.74c.22.52.47,1,.72,1.55l-.31-.44c-.61-.7-2.2-1.7-3.16-1.3a1.24,1.24,0,0,0-.54,1.76,2.58,2.58,0,0,0,1.89,1.06,8,8,0,0,0,2.46-.38c.1.2.2.39.29.59.48.94,1,1.88,1.39,2.81.16.33.3.66.44,1l-.27-.38c-.61-.7-2.2-1.7-3.16-1.3a1.23,1.23,0,0,0-.54,1.75,2.55,2.55,0,0,0,1.89,1.07,7.87,7.87,0,0,0,2.4-.36c.13.34.27.68.38,1s.16.45.22.69.13.46.2.69c.1.44.22.9.31,1.34s.13.59.19.89c-.15-.33-.46-1-.49-1-.5-.79-1.92-2-2.93-1.76a1.23,1.23,0,0,0-.8,1.65,2.55,2.55,0,0,0,1.7,1.33,8.57,8.57,0,0,0,2.56,0c.09.48.18.95.26,1.4s.11.65.16.95h.65c-.06-.34-.13-.69-.2-1.07s-.21-1-.33-1.55A14.33,14.33,0,0,0,43,437a8.83,8.83,0,0,0,2.08,1.34c-.19.46-.37.9-.55,1.32l-.28.63h.68l.17-.39c.19-.47.38-1,.58-1.48a8.41,8.41,0,0,0,2.54.2A2.63,2.63,0,0,0,50,437.36a1.23,1.23,0,0,0-.69-1.7c-1-.33-2.49.79-3,1.54,0,0-.34.56-.52.89l.24-.63.46-1.33c.06-.23.13-.46.2-.69s.12-.48.19-.72c.13-.57.24-1.15.34-1.73a8.23,8.23,0,0,0,2.41.56,2.6,2.6,0,0,0,2-.92,1.24,1.24,0,0,0-.42-1.79c-.92-.48-2.58.4-3.24,1.06l-.69.85c.06-.35.11-.7.16-1.06.13-1,.22-2.08.33-3.13,0-.32.06-.64.1-.95a8.34,8.34,0,0,0,2.49.58,2.57,2.57,0,0,0,2-.92,1.24,1.24,0,0,0-.42-1.79c-.92-.47-2.58.41-3.24,1.06,0,0-.65.81-.8,1,.08-.71.16-1.41.26-2.09a23.64,23.64,0,0,1,.6-2.76,8.49,8.49,0,0,0,2.52.59,2.53,2.53,0,0,0,2-.92,1.23,1.23,0,0,0-.41-1.78c-.93-.48-2.59.4-3.25,1.06,0,.05-.7.86-.81,1,0-.06,0-.11.05-.16a15.36,15.36,0,0,1,1.09-2.61c.23-.46.49-.89.74-1.3a8.69,8.69,0,0,0,2.38.83,2.56,2.56,0,0,0,2-.7,1.23,1.23,0,0,0-.21-1.82c-.87-.57-2.62.12-3.34.7l-.67.66.35-.55c.43-.65.87-1.23,1.27-1.73.22-.29.43-.54.63-.78a8.14,8.14,0,0,0,2.49-.35,2.59,2.59,0,0,0,1.5-1.57,1.24,1.24,0,0,0-1-1.52c-1-.11-2.27,1.31-2.65,2.16,0,.08-.41,1.28-.39,1.28h0l-.62.73c-.41.5-.86,1.07-1.32,1.72a22.41,22.41,0,0,0-1.35,2.16,15.26,15.26,0,0,0-1.16,2.62v0c0-.31,0-1.16,0-1.23-.12-.92-.89-2.63-1.92-2.82a1.23,1.23,0,0,0-1.42,1.16,2.57,2.57,0,0,0,1,1.93,8.62,8.62,0,0,0,2.34,1.07,20.89,20.89,0,0,0-.69,2.83c-.1.55-.18,1.12-.26,1.69,0-.27,0-.5,0-.54-.12-.92-.89-2.63-1.92-2.82a1.23,1.23,0,0,0-1.42,1.16,2.59,2.59,0,0,0,1,1.93,7.92,7.92,0,0,0,2.26,1c0,.22,0,.44-.08.66-.12,1-.24,2.08-.39,3.11-.05.36-.12.71-.18,1.06,0-.23,0-.43,0-.46-.12-.92-.89-2.64-1.91-2.83a1.23,1.23,0,0,0-1.42,1.16,2.55,2.55,0,0,0,1,1.93,7.9,7.9,0,0,0,2.21,1c-.08.36-.16.72-.25,1.06s-.11.46-.19.69-.15.46-.22.69l-.48,1.29-.33.84c.05-.36.15-1.06.15-1.12a5,5,0,0,0-.64-2.33,2.45,2.45,0,0,0,0-.27,1.22,1.22,0,0,0-1.51-1c-1,.26-1.64,2-1.69,3,0,.05,0,.65.06,1l-.15-.66c-.11-.44-.23-.88-.35-1.36l-.21-.69c-.06-.23-.16-.47-.24-.7-.2-.55-.43-1.09-.67-1.63a7.8,7.8,0,0,0,2.32-.87,2.55,2.55,0,0,0,1.13-1.85A1.23,1.23,0,0,0,42,428.31c-1,.11-1.94,1.76-2.12,2.67,0,.06-.08.73-.1,1.1-.15-.33-.3-.65-.46-1-.46-.93-1-1.86-1.45-2.79l-.45-.85a8.7,8.7,0,0,0,2.41-.89A2.59,2.59,0,0,0,41,424.72a1.23,1.23,0,0,0-1.33-1.27c-1,.12-1.94,1.77-2.12,2.68,0,.07-.1,1-.11,1.28-.33-.63-.65-1.26-.94-1.89a21.9,21.9,0,0,1-1-2.63,8.78,8.78,0,0,0,2.43-.89A2.62,2.62,0,0,0,39,420.15a1.25,1.25,0,0,0-1.34-1.27c-1,.12-1.93,1.77-2.12,2.68,0,.07-.11,1.1-.11,1.29,0-.05,0-.1,0-.15a16,16,0,0,1-.53-2.78c-.06-.51-.08-1-.1-1.5a8.44,8.44,0,0,0,2.45-.61,2.55,2.55,0,0,0,1.32-1.72,1.23,1.23,0,0,0-1.18-1.4c-1,0-2.12,1.54-2.4,2.43,0,.05-.12.55-.2.92,0-.22,0-.44,0-.65,0-.79.06-1.51.11-2.15,0-.36.06-.69.1-1a8,8,0,0,0,1.87-1.66,2.56,2.56,0,0,0,.39-2.14,1.22,1.22,0,0,0-1.69-.69c-.93.47-1.17,2.34-1,3.26,0,.07.36,1.29.38,1.28h0c0,.29-.08.61-.12,1-.07.64-.13,1.36-.15,2.16a22.26,22.26,0,0,0,.06,2.55,16.11,16.11,0,0,0,.47,2.82v0c-.16-.26-.64-1-.68-1-.61-.7-2.2-1.71-3.16-1.3a1.23,1.23,0,0,0-.55,1.75A2.57,2.57,0,0,0,32.66,423.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "43.8865px 424.957px"
    },
    id: "eljcks1iit1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.53,418.4s.33-1.21.34-1.29c.13-.92-.16-2.78-1.1-3.23a1.23,1.23,0,0,0-1.68.74,2.57,2.57,0,0,0,.45,2.12A8.62,8.62,0,0,0,50.53,418.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "49.462px 416.085px"
    },
    id: "elxmfqs8we8dm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.42,426.54a5.54,5.54,0,0,0,1.59.18s-.25-.74-.27-.79c-.24-.51-1-1.37-1.66-1.28a.76.76,0,0,0-.61,1A1.58,1.58,0,0,0,447.42,426.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "447.719px 425.683px"
    },
    id: "elpls7yl1tgz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.81,429.8a5.39,5.39,0,0,0,1.56-.24,14.31,14.31,0,0,0,.61,1.69c.14.32.29.63.44.95l-.19-.27c-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08,1.61,1.61,0,0,0,1.17.66,4.94,4.94,0,0,0,1.52-.24c.06.12.11.25.17.37.3.58.59,1.15.86,1.73l.27.61-.17-.24c-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08,1.58,1.58,0,0,0,1.17.66,5.07,5.07,0,0,0,1.48-.22c.08.21.16.42.23.63s.1.27.14.42l.12.43c.06.27.13.55.19.82l.12.55c-.1-.21-.29-.6-.31-.63-.3-.49-1.18-1.24-1.8-1.08a.74.74,0,0,0-.49,1,1.54,1.54,0,0,0,1.05.82,5,5,0,0,0,1.57,0c.06.3.12.59.16.86s.07.4.1.59h.4q-.06-.32-.12-.66c-.06-.3-.13-.62-.21-.95a8,8,0,0,0,.88-.41,5.61,5.61,0,0,0,1.28.82c-.11.28-.23.55-.34.81s-.12.26-.17.39h.42l.1-.24c.12-.29.24-.59.36-.91a5.57,5.57,0,0,0,1.57.12,1.6,1.6,0,0,0,1.11-.74.76.76,0,0,0-.42-1.05c-.61-.21-1.54.48-1.88.94l-.32.56.15-.39c.09-.27.18-.54.28-.82s.08-.28.13-.43.07-.29.11-.44c.08-.35.15-.71.21-1.07a4.8,4.8,0,0,0,1.49.35,1.59,1.59,0,0,0,1.21-.57.75.75,0,0,0-.26-1.1c-.57-.3-1.59.25-2,.65l-.43.53c0-.22.07-.43.1-.65.08-.64.14-1.29.2-1.93l.06-.59a5.43,5.43,0,0,0,1.54.36,1.59,1.59,0,0,0,1.21-.57.76.76,0,0,0-.25-1.1c-.57-.29-1.6.25-2,.65,0,0-.41.5-.49.62,0-.43.09-.86.16-1.29a13,13,0,0,1,.37-1.69,5.32,5.32,0,0,0,1.55.36,1.6,1.6,0,0,0,1.21-.56.77.77,0,0,0-.26-1.11c-.57-.29-1.59.25-2,.66,0,0-.43.53-.5.63l0-.1a10.23,10.23,0,0,1,.67-1.61c.15-.28.3-.55.46-.8a4.92,4.92,0,0,0,1.46.51,1.59,1.59,0,0,0,1.27-.43.76.76,0,0,0-.13-1.12c-.54-.35-1.61.07-2.06.43l-.41.41.21-.34c.27-.4.54-.76.78-1.07s.27-.33.4-.48a5.15,5.15,0,0,0,1.53-.21,1.63,1.63,0,0,0,.92-1,.75.75,0,0,0-.63-.93c-.64-.07-1.4.8-1.63,1.33,0,0-.26.78-.25.78h0l-.39.45c-.25.31-.53.66-.8,1.06a12.7,12.7,0,0,0-.84,1.33,10.75,10.75,0,0,0-.72,1.61v0c0-.19,0-.71,0-.75-.08-.57-.55-1.62-1.18-1.74a.76.76,0,0,0-.88.71,1.57,1.57,0,0,0,.61,1.19,5.54,5.54,0,0,0,1.44.66,12.27,12.27,0,0,0-.42,1.74c-.06.35-.12.69-.16,1,0-.16,0-.3,0-.32-.07-.57-.55-1.63-1.18-1.74a.76.76,0,0,0-.88.71,1.59,1.59,0,0,0,.61,1.19,5,5,0,0,0,1.4.64c0,.14,0,.27-.05.4-.08.65-.15,1.29-.25,1.92,0,.22-.07.44-.11.66a1.72,1.72,0,0,0,0-.29c-.07-.57-.55-1.62-1.18-1.74a.76.76,0,0,0-.87.72,1.55,1.55,0,0,0,.61,1.18,4.63,4.63,0,0,0,1.35.63,6.38,6.38,0,0,1-.15.66c0,.14-.07.29-.12.43l-.13.42-.3.8-.2.51c0-.22.09-.65.09-.69a2.89,2.89,0,0,0-.39-1.43c0-.06,0-.11,0-.17a.76.76,0,0,0-.93-.64c-.62.16-1,1.25-1.05,1.82,0,0,0,.41,0,.64l-.09-.41-.22-.84c0-.14-.08-.28-.13-.42s-.1-.29-.15-.43c-.12-.34-.26-.67-.41-1a4.78,4.78,0,0,0,1.43-.53,1.61,1.61,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0,0,.44-.06.67-.09-.2-.18-.4-.28-.6l-.89-1.72c-.1-.17-.19-.35-.28-.52a5.33,5.33,0,0,0,1.48-.55,1.61,1.61,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0-.06.63-.07.78-.2-.38-.39-.77-.57-1.16a13.52,13.52,0,0,1-.63-1.62A5.38,5.38,0,0,0,451,429a1.59,1.59,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0-.06.68-.07.8l0-.1a9.74,9.74,0,0,1-.32-1.7c0-.32-.06-.63-.07-.93a5,5,0,0,0,1.51-.38,1.58,1.58,0,0,0,.82-1.05.77.77,0,0,0-.73-.87c-.64,0-1.31.95-1.48,1.5,0,0-.08.34-.12.57,0-.14,0-.28,0-.41,0-.48,0-.93.07-1.32,0-.22,0-.42.06-.61a5.23,5.23,0,0,0,1.16-1,1.57,1.57,0,0,0,.23-1.31.74.74,0,0,0-1-.43c-.57.29-.72,1.44-.63,2,0,.05.23.8.24.8h0c0,.18-.05.37-.08.59,0,.39-.07.83-.09,1.32a14.3,14.3,0,0,0,0,1.58,10.08,10.08,0,0,0,.29,1.73v0c-.1-.16-.4-.59-.43-.62-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08A1.57,1.57,0,0,0,447.81,429.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "454.669px 430.828px"
    },
    id: "el8p6o9qvxaln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.81,426.79s.21-.75.21-.8c.08-.57-.1-1.71-.68-2a.76.76,0,0,0-1,.46,1.59,1.59,0,0,0,.28,1.31A5.4,5.4,0,0,0,458.81,426.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "458.169px 425.363px"
    },
    id: "el0mqvrfbgkb79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.72,426.54a5.54,5.54,0,0,0,1.59.18s-.25-.74-.27-.79c-.24-.51-1-1.37-1.66-1.28a.76.76,0,0,0-.61,1A1.58,1.58,0,0,0,98.72,426.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.0192px 425.683px"
    },
    id: "el1qz5wahxmo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,429.8a5.39,5.39,0,0,0,1.56-.24,14.31,14.31,0,0,0,.61,1.69c.14.32.29.63.44.95l-.19-.27c-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08,1.61,1.61,0,0,0,1.17.66,4.94,4.94,0,0,0,1.52-.24c.06.12.11.25.17.37.3.58.59,1.15.86,1.73l.27.61-.17-.24c-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08A1.58,1.58,0,0,0,102,436a5.07,5.07,0,0,0,1.48-.22c.08.21.16.42.23.63s.1.27.14.42l.12.43c.06.27.13.55.19.82l.12.55c-.1-.21-.29-.6-.31-.63-.3-.49-1.18-1.24-1.8-1.08a.74.74,0,0,0-.49,1,1.54,1.54,0,0,0,1,.82,5,5,0,0,0,1.57,0c.06.3.12.59.16.86s.07.4.1.59h.4l-.12-.66c-.06-.3-.13-.62-.21-.95a8,8,0,0,0,.88-.41,5.61,5.61,0,0,0,1.28.82c-.11.28-.23.55-.34.81s-.12.26-.17.39h.42l.1-.24c.12-.29.24-.59.36-.91a5.57,5.57,0,0,0,1.57.12,1.6,1.6,0,0,0,1.11-.74.76.76,0,0,0-.42-1.05c-.61-.21-1.54.48-1.88.94l-.32.56.15-.39c.09-.27.18-.54.28-.82s.08-.28.13-.43.07-.29.11-.44c.08-.35.15-.71.21-1.07a4.8,4.8,0,0,0,1.49.35,1.59,1.59,0,0,0,1.21-.57.75.75,0,0,0-.26-1.1c-.57-.3-1.59.25-2,.65l-.43.53c0-.22.07-.43.1-.65.08-.64.14-1.29.2-1.93l.06-.59a5.43,5.43,0,0,0,1.54.36,1.59,1.59,0,0,0,1.21-.57.76.76,0,0,0-.25-1.1c-.57-.29-1.6.25-2,.65,0,0-.41.5-.49.62,0-.43.09-.86.16-1.29a13,13,0,0,1,.37-1.69,5.32,5.32,0,0,0,1.55.36,1.6,1.6,0,0,0,1.21-.56.77.77,0,0,0-.26-1.11c-.57-.29-1.59.25-2,.66,0,0-.43.53-.5.63l0-.1a10.23,10.23,0,0,1,.67-1.61c.15-.28.3-.55.46-.8a4.92,4.92,0,0,0,1.46.51,1.59,1.59,0,0,0,1.27-.43.76.76,0,0,0-.13-1.12c-.54-.35-1.61.07-2.06.43l-.41.41.21-.34c.27-.4.54-.76.78-1.07s.27-.33.4-.48a5.15,5.15,0,0,0,1.53-.21,1.63,1.63,0,0,0,.92-1,.75.75,0,0,0-.63-.93c-.64-.07-1.4.8-1.63,1.33,0,0-.26.78-.25.78h0l-.39.45c-.25.31-.53.66-.8,1.06a12.7,12.7,0,0,0-.84,1.33,10.75,10.75,0,0,0-.72,1.61v0c0-.19,0-.71,0-.75-.08-.57-.55-1.62-1.18-1.74a.76.76,0,0,0-.88.71,1.57,1.57,0,0,0,.61,1.19,5.54,5.54,0,0,0,1.44.66,12.27,12.27,0,0,0-.42,1.74c-.06.35-.12.69-.16,1,0-.16,0-.3,0-.32-.07-.57-.55-1.63-1.18-1.74a.76.76,0,0,0-.88.71,1.59,1.59,0,0,0,.61,1.19,5,5,0,0,0,1.4.64c0,.14,0,.27,0,.4-.08.65-.15,1.29-.25,1.92,0,.22-.07.44-.11.66a1.72,1.72,0,0,0,0-.29c-.07-.57-.55-1.62-1.18-1.74a.76.76,0,0,0-.87.72,1.55,1.55,0,0,0,.61,1.18,4.63,4.63,0,0,0,1.35.63,6.38,6.38,0,0,1-.15.66c0,.14-.07.29-.12.43s-.09.28-.13.42l-.3.8-.2.51c0-.22.09-.65.09-.69a2.89,2.89,0,0,0-.39-1.43c0-.06,0-.11,0-.17a.76.76,0,0,0-.93-.64c-.62.16-1,1.25-1,1.82,0,0,0,.41,0,.64l-.09-.41-.22-.84c0-.14-.08-.28-.13-.42s-.1-.29-.15-.43c-.12-.34-.26-.67-.41-1a4.78,4.78,0,0,0,1.43-.53,1.61,1.61,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0,0,.44-.06.67-.09-.2-.18-.4-.28-.6-.29-.57-.59-1.14-.9-1.72l-.27-.52a5.33,5.33,0,0,0,1.48-.55,1.61,1.61,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0-.06.63-.07.78-.2-.38-.39-.77-.57-1.16a13.52,13.52,0,0,1-.63-1.62,5.38,5.38,0,0,0,1.49-.55,1.59,1.59,0,0,0,.7-1.14.76.76,0,0,0-.82-.78c-.64.07-1.19,1.09-1.31,1.65,0,0-.06.68-.07.8l0-.1a9.74,9.74,0,0,1-.32-1.7c0-.32-.06-.63-.07-.93a5,5,0,0,0,1.51-.38,1.58,1.58,0,0,0,.82-1.05.77.77,0,0,0-.73-.87c-.64,0-1.31.95-1.48,1.5,0,0-.08.34-.12.57,0-.14,0-.28,0-.41,0-.48,0-.93.07-1.32,0-.22,0-.42.06-.61a5.46,5.46,0,0,0,1.16-1,1.57,1.57,0,0,0,.23-1.31.74.74,0,0,0-1-.43c-.57.29-.72,1.44-.63,2,0,.05.23.8.24.8h0c0,.18,0,.37-.08.59,0,.39-.07.83-.09,1.32a14.3,14.3,0,0,0,0,1.58,10.08,10.08,0,0,0,.29,1.73v0c-.1-.16-.4-.59-.43-.62-.37-.43-1.35-1.05-1.94-.8a.76.76,0,0,0-.34,1.08A1.57,1.57,0,0,0,99.11,429.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.984px 430.743px"
    },
    id: "elh2fcev0ctg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.11,426.79s.21-.75.21-.8c.08-.57-.1-1.71-.68-2a.76.76,0,0,0-1,.46,1.59,1.59,0,0,0,.28,1.31A5.4,5.4,0,0,0,110.11,426.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.469px 425.363px"
    },
    id: "elwifys8wyvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,419.44a8.38,8.38,0,0,0,2.41.26s-.36-1.12-.4-1.18c-.37-.79-1.56-2.09-2.52-2a1.16,1.16,0,0,0-.93,1.45A2.42,2.42,0,0,0,400.92,419.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.385px 418.111px"
    },
    id: "elganxj31t61",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.51,424.39a8.17,8.17,0,0,0,2.38-.37,20.18,20.18,0,0,0,.92,2.56c.21.49.44,1,.67,1.45l-.28-.41c-.57-.66-2.06-1.59-3-1.21a1.16,1.16,0,0,0-.51,1.64,2.41,2.41,0,0,0,1.77,1,7.49,7.49,0,0,0,2.31-.35l.27.55c.44.88.89,1.76,1.3,2.63.14.31.27.62.41.92l-.25-.35c-.57-.66-2.06-1.6-3-1.21a1.15,1.15,0,0,0-.51,1.63,2.39,2.39,0,0,0,1.77,1,7.29,7.29,0,0,0,2.25-.34c.12.32.25.64.36,1s.15.42.2.64l.18.65c.1.41.21.84.3,1.25s.11.56.17.83c-.14-.31-.43-.9-.46-1-.46-.74-1.79-1.89-2.73-1.65a1.16,1.16,0,0,0-.76,1.54A2.42,2.42,0,0,0,407,438a8.13,8.13,0,0,0,2.39,0c.09.45.17.89.25,1.31s.1.61.15.89h.6c0-.32-.12-.65-.19-1s-.19-.95-.31-1.45a11.75,11.75,0,0,0,1.34-.63,8.45,8.45,0,0,0,1.94,1.26c-.17.43-.35.84-.52,1.23-.09.2-.17.4-.26.59H413l.15-.37c.18-.43.36-.9.55-1.38a8.07,8.07,0,0,0,2.38.19,2.49,2.49,0,0,0,1.69-1.13,1.17,1.17,0,0,0-.64-1.6c-.92-.31-2.34.74-2.85,1.44,0,0-.31.53-.49.84l.23-.59c.14-.41.28-.81.42-1.25.07-.21.13-.42.2-.64s.11-.45.17-.68c.13-.52.23-1.06.32-1.61a7.69,7.69,0,0,0,2.26.52,2.46,2.46,0,0,0,1.84-.86,1.15,1.15,0,0,0-.39-1.67c-.87-.45-2.42.37-3,1l-.64.8c.05-.33.11-.66.15-1,.12-1,.21-1.95.3-2.93,0-.3.07-.6.1-.9A7.92,7.92,0,0,0,418,429a2.4,2.4,0,0,0,1.83-.86,1.15,1.15,0,0,0-.38-1.67c-.87-.45-2.42.37-3,1-.05,0-.61.75-.75.94.07-.66.15-1.32.25-2a20.5,20.5,0,0,1,.56-2.57,8.3,8.3,0,0,0,2.35.55,2.42,2.42,0,0,0,1.84-.86,1.14,1.14,0,0,0-.39-1.67c-.86-.45-2.42.37-3,1,0,0-.66.81-.76.95a.83.83,0,0,1,0-.15,15.28,15.28,0,0,1,1-2.43c.22-.44.46-.84.69-1.23a7.82,7.82,0,0,0,2.23.79,2.41,2.41,0,0,0,1.92-.66,1.15,1.15,0,0,0-.2-1.7c-.81-.54-2.45.11-3.13.65l-.62.62c.11-.17.22-.35.33-.51.4-.62.82-1.15,1.18-1.63l.6-.72a7.91,7.91,0,0,0,2.32-.33A2.44,2.44,0,0,0,424.3,415a1.16,1.16,0,0,0-1-1.42c-1-.1-2.12,1.23-2.47,2,0,.07-.39,1.2-.37,1.2h0l-.59.68c-.37.47-.8,1-1.22,1.61a19.6,19.6,0,0,0-1.27,2,14.42,14.42,0,0,0-1.09,2.45v0c0-.29,0-1.09,0-1.15-.11-.86-.84-2.46-1.8-2.64a1.15,1.15,0,0,0-1.33,1.08,2.45,2.45,0,0,0,.93,1.81,8,8,0,0,0,2.19,1,20,20,0,0,0-.65,2.64c-.09.53-.17,1.05-.24,1.58,0-.24,0-.46,0-.49-.11-.87-.84-2.47-1.79-2.65a1.16,1.16,0,0,0-1.33,1.09,2.4,2.4,0,0,0,.92,1.8,7.67,7.67,0,0,0,2.12,1c0,.2-.05.41-.08.61-.11,1-.22,2-.36,2.91-.05.34-.11.67-.17,1,0-.22,0-.41,0-.44-.11-.86-.83-2.46-1.79-2.64a1.16,1.16,0,0,0-1.33,1.09,2.38,2.38,0,0,0,.93,1.8,7.35,7.35,0,0,0,2.05,1c-.07.34-.14.67-.22,1s-.11.44-.18.66l-.21.64c-.15.4-.29.81-.45,1.2s-.21.53-.31.79c.05-.33.14-1,.14-1.05a4.44,4.44,0,0,0-.6-2.18,1,1,0,0,0,0-.25,1.16,1.16,0,0,0-1.41-1c-.95.25-1.54,1.91-1.59,2.77,0,.06,0,.62.06,1,0-.21-.09-.41-.14-.62-.1-.41-.21-.83-.33-1.27-.06-.21-.13-.43-.19-.65s-.16-.43-.23-.65q-.28-.76-.63-1.53a7.13,7.13,0,0,0,2.17-.81,2.39,2.39,0,0,0,1.06-1.73,1.14,1.14,0,0,0-1.24-1.18c-1,.1-1.81,1.65-2,2.5,0,.05-.07.68-.09,1l-.43-.91c-.43-.87-.9-1.74-1.36-2.61-.14-.26-.27-.53-.41-.8a7.84,7.84,0,0,0,2.25-.83,2.43,2.43,0,0,0,1.06-1.73,1.16,1.16,0,0,0-1.25-1.18c-1,.1-1.81,1.65-2,2.5,0,.06-.09,1-.1,1.19-.3-.58-.6-1.17-.87-1.76a20.81,20.81,0,0,1-1-2.46,7.81,7.81,0,0,0,2.27-.84,2.4,2.4,0,0,0,1.06-1.73,1.16,1.16,0,0,0-1.25-1.18c-1,.11-1.81,1.65-2,2.5,0,.07-.1,1-.11,1.22a.88.88,0,0,0-.05-.15,14.7,14.7,0,0,1-.49-2.59c-.05-.49-.08-.95-.09-1.41a7.54,7.54,0,0,0,2.28-.57,2.41,2.41,0,0,0,1.25-1.61,1.15,1.15,0,0,0-1.11-1.31c-1,0-2,1.44-2.25,2.27,0,.05-.11.52-.18.87,0-.21,0-.42,0-.62,0-.73.05-1.41.1-2,0-.34.06-.64.09-.93a7.72,7.72,0,0,0,1.76-1.56,2.4,2.4,0,0,0,.36-2,1.15,1.15,0,0,0-1.59-.65c-.86.44-1.09,2.19-.95,3,0,.08.34,1.22.36,1.21h0c0,.27-.07.57-.11.89-.06.6-.12,1.27-.14,2s0,1.54.06,2.39a16,16,0,0,0,.44,2.64v0c-.15-.24-.6-.9-.64-.95-.57-.66-2.06-1.59-2.95-1.21a1.16,1.16,0,0,0-.52,1.64A2.43,2.43,0,0,0,401.51,424.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.917px 425.881px"
    },
    id: "elrg9fft6183",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.23,419.81s.31-1.13.32-1.21c.12-.86-.16-2.6-1-3a1.14,1.14,0,0,0-1.56.69,2.41,2.41,0,0,0,.41,2A8.13,8.13,0,0,0,418.23,419.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.25px 417.653px"
    },
    id: "el76qp42bdu4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "251.97px 60.7111px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elb7j6eksyi1v"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "251.97px 60.7111px"
    },
    className: "animable",
    id: "el6vhbmx2tz8i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.78,90.49H331.27l1.81-2.41a3.61,3.61,0,0,1,3.25-1.19,2.43,2.43,0,0,0,1.09-.13,3.6,3.6,0,0,0,.65-.92,11.46,11.46,0,0,1,4.24-4.36c1.94-1.13,4-.74,5.49-.46s2,.3,2.16-.25c.76-2.79,2.68-5.62,5.8-5.2a18.14,18.14,0,0,1,2.63.61c2.48.7,4,1,4.71-.52,1.25-2.91,3.6-6.63,9.65-5.34,5.76,1.24,8.25,7.5,8.43,8,1.17,2.52,3.45,2.29,6.09,2,2.25-.23,4.79-.48,6.7,1.22,4.06,3.63,2,8.6,1.94,8.65Zm-62.51-1h61.84a6.64,6.64,0,0,0-1.8-7.2c-1.59-1.41-3.7-1.2-5.94-1-2.77.28-5.63.57-7.1-2.62l0,0c0-.06-2.4-6.22-7.71-7.36s-7.32,2-8.52,4.76c-1,2.45-3.63,1.72-5.91,1.08a18.2,18.2,0,0,0-2.49-.58c-3.1-.42-4.38,3.32-4.7,4.48-.41,1.52-1.88,1.24-3.3,1a6.58,6.58,0,0,0-4.8.34,10.54,10.54,0,0,0-3.89,4,4.15,4.15,0,0,1-.91,1.2,2.73,2.73,0,0,1-1.7.33,2.7,2.7,0,0,0-2.44.79Z",
    id: "el6rw8rolqqsi",
    className: "animable",
    style: {
      transformOrigin: "363.878px 80.2734px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,97.56H22l2.23-3c1.17-1.55,2.94-1.53,4.23-1.53a3.13,3.13,0,0,0,1.58-.2A5.37,5.37,0,0,0,31,91.56a15.13,15.13,0,0,1,5.65-5.81c2.55-1.5,5.28-1,7.27-.6s2.85.46,3.11-.46c1-3.69,3.54-7.44,7.61-6.89a25.32,25.32,0,0,1,3.53.82c3.45,1,5.61,1.41,6.56-.8,1.65-3.86,4.78-8.8,12.8-7.09,7.69,1.65,11,10.06,11.23,10.63,1.64,3.52,4.76,3.21,8.38,2.84,3.14-.31,6.39-.64,8.9,1.61,5.37,4.81,2.6,11.38,2.57,11.45ZM24,96.56h83.78a9.12,9.12,0,0,0-2.44-10c-2.18-2-5.2-1.65-8.13-1.35-3.67.36-7.46.75-9.39-3.43l0,0c0-.08-3.26-8.46-10.51-10s-10,2.67-11.68,6.51c-1.35,3.17-4.6,2.25-7.75,1.36a24.53,24.53,0,0,0-3.38-.79c-4.33-.58-6.09,4.57-6.52,6.16-.52,1.89-2.33,1.55-4.25,1.18s-4.36-.83-6.59.48a14.43,14.43,0,0,0-5.3,5.47,5.49,5.49,0,0,1-1.18,1.57,3.59,3.59,0,0,1-2.19.4c-1.25,0-2.56,0-3.42,1.13Z",
    id: "el8kxitpwjh8u",
    className: "animable",
    style: {
      transformOrigin: "65.6753px 83.9708px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.75,63.06H355.27l3-4c1.63-2.17,4-2.15,6-2.14a4.7,4.7,0,0,0,2.45-.34,7.82,7.82,0,0,0,1.4-1.94,21.94,21.94,0,0,1,8.16-8.4c3.66-2.15,7.43-1.43,10.46-.85s4.35.75,4.78-.84c1.45-5.28,5.06-10.65,10.87-9.88a38.67,38.67,0,0,1,5.1,1.19c4.45,1.26,8.28,2.34,9.84-1.29,2.38-5.56,6.88-12.68,18.41-10.2,11.14,2.38,15.94,14.62,16.23,15.36C454.37,45,459,44.57,464.38,44c4.53-.45,9.21-.93,12.8,2.29,7.72,6.9,3.74,16.34,3.7,16.43Zm-123.48-1H480.08c.6-1.62,2.94-9.18-3.56-15-3.27-2.92-7.72-2.47-12-2-5.27.54-10.72,1.08-13.47-4.86v0c-.05-.12-4.8-12.46-15.51-14.76S420.64,29.3,418.21,35c-1.9,4.43-6.54,3.12-11,1.86a36.34,36.34,0,0,0-5-1.17c-6.48-.86-9.12,6.79-9.76,9.16-.7,2.55-3.13,2.09-5.94,1.55s-6.44-1.22-9.76.73a21.16,21.16,0,0,0-7.81,8.06,8,8,0,0,1-1.66,2.22,5,5,0,0,1-3.06.54c-1.8,0-3.85,0-5.17,1.74Z",
    id: "elmb09w77t6hf",
    className: "animable",
    style: {
      transformOrigin: "418.605px 43.4611px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-2",
    className: "animable",
    style: {
      transformOrigin: "254.95px 170.425px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elnwix9gqj2za"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "254.95px 170.425px"
    },
    className: "animable",
    id: "elemp7u9w8q5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.9,224.92H473.74a.5.5,0,0,1-.5-.5V198.63a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v25.29H487.9a.5.5,0,0,1,.5.5A.5.5,0,0,1,487.9,224.92Z",
    id: "elb485bdv97s7",
    className: "animable",
    style: {
      transformOrigin: "480.82px 211.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.74,192a.5.5,0,0,1-.5-.5V132.74H460.41a.5.5,0,0,1-.5-.5V116.07h-5.75a.5.5,0,0,1-.5-.5v-6.25a.5.5,0,0,1,.5-.5h5.75v-8.58H413.82V153.9a.5.5,0,0,1-.5.5H397.49a.5.5,0,0,1-.5-.5V115.66H380.76a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.73a.5.5,0,0,1,.5.5V153.4h14.83V99.74a.5.5,0,0,1,.5-.5h47.09a.5.5,0,0,1,.5.5v9.58a.5.5,0,0,1-.5.5h-5.75v5.25h5.75a.51.51,0,0,1,.5.5v16.17h12.83a.5.5,0,0,1,.5.5v59.27A.51.51,0,0,1,473.74,192Z",
    id: "el7s6wbsvsi69",
    className: "animable",
    style: {
      transformOrigin: "427.25px 145.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,157.29H336.66a.5.5,0,0,1-.5-.5V103.17H318.71a.51.51,0,0,1-.5-.5V67.27H219.79v36.82a.5.5,0,0,1-.5.5h-12a.5.5,0,0,1-.5-.5V77.67a.5.5,0,0,1,.5-.5h3.77V69.06H196v8.17h5.05a.51.51,0,0,1,.5.5v61a.51.51,0,0,1-.5.5h-11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h10.51v-60h-5.05a.5.5,0,0,1-.5-.5V68.56a.5.5,0,0,1,.5-.5H211.6a.5.5,0,0,1,.5.5v9.11a.5.5,0,0,1-.5.5h-3.77v25.42h11V66.77a.51.51,0,0,1,.5-.5h99.42a.5.5,0,0,1,.5.5v35.4h17.45a.5.5,0,0,1,.5.5v53.62H352V115.16a.5.5,0,0,1,.5-.5h21.14a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H353v41.13A.5.5,0,0,1,352.49,157.29Z",
    id: "elemww7tvaick",
    className: "animable",
    style: {
      transformOrigin: "281.845px 111.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,140.51h-9.83a.5.5,0,0,1-.5-.5V120.19H89.08a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h22.19a.5.5,0,0,1,.5.5v19.82h8.83V84.94a.51.51,0,0,1,.5-.5h38.68a.5.5,0,0,1,.5.5v18.52h8a.5.5,0,0,1,.5.5v13.92h8.68a.5.5,0,0,1,.5.5V138.2h6.74a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-7.24a.5.5,0,0,1-.5-.5V118.88H168.3a.51.51,0,0,1-.5-.5V104.46h-8a.5.5,0,0,1-.5-.5V85.44H121.6V140A.5.5,0,0,1,121.1,140.51Z",
    id: "elrg34mxdmasr",
    className: "animable",
    style: {
      transformOrigin: "136.89px 112.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,227.69H33.26a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H47.84V152.46a.5.5,0,0,1,.5-.5H70.13V119.69a.5.5,0,0,1,.5-.5H82a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H71.13v32.27a.5.5,0,0,1-.5.5H48.84v74.23A.5.5,0,0,1,48.34,227.69Z",
    id: "elwdql1xercg",
    className: "animable",
    style: {
      transformOrigin: "57.63px 173.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.94,156.07a.5.5,0,0,1-.5-.5V84.23H236.68v48.46a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-49a.5.5,0,0,1,.5-.5h74.76a.5.5,0,0,1,.5.5v71.84A.51.51,0,0,1,310.94,156.07Z",
    id: "elvy95wxhi8un",
    className: "animable",
    style: {
      transformOrigin: "273.56px 119.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,160.15a.5.5,0,0,1-.5-.5V138a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v21.61A.5.5,0,0,1,236.18,160.15Z",
    id: "el2hpljs3o9by",
    className: "animable",
    style: {
      transformOrigin: "236.181px 148.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,99.41H264.21a.5.5,0,0,1-.5-.5V94.24a.5.5,0,0,1,.5-.5h46.14a.5.5,0,0,1,.5.5v4.67A.5.5,0,0,1,310.35,99.41Zm-45.64-1h45.14V94.74H264.71Z",
    id: "elyjk7ydq1b8g",
    className: "animable",
    style: {
      transformOrigin: "287.28px 96.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,111.68H264.21a.51.51,0,0,1-.5-.5V106.5a.51.51,0,0,1,.5-.5h46.14a.5.5,0,0,1,.5.5v4.68A.5.5,0,0,1,310.35,111.68Zm-45.64-1h45.14V107H264.71Z",
    id: "el8cf73ylzbp",
    className: "animable",
    style: {
      transformOrigin: "287.28px 108.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,123.94H264.21a.5.5,0,0,1-.5-.5v-4.67a.5.5,0,0,1,.5-.5h46.14a.5.5,0,0,1,.5.5v4.67A.5.5,0,0,1,310.35,123.94Zm-45.64-1h45.14v-3.67H264.71Z",
    id: "eljsu20thmv4",
    className: "animable",
    style: {
      transformOrigin: "287.28px 121.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,136.21H264.21a.51.51,0,0,1-.5-.5V131a.5.5,0,0,1,.5-.5h46.14a.5.5,0,0,1,.5.5v4.67A.5.5,0,0,1,310.35,136.21Zm-45.64-1h45.14v-3.67H264.71Z",
    id: "eljxe0h1wq31m",
    className: "animable",
    style: {
      transformOrigin: "287.281px 133.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.35,148.47H264.21a.5.5,0,0,1-.5-.5V143.3a.5.5,0,0,1,.5-.5h46.14a.5.5,0,0,1,.5.5V148A.5.5,0,0,1,310.35,148.47Zm-45.64-1h45.14V143.8H264.71Z",
    id: "elfcq3f223hf",
    className: "animable",
    style: {
      transformOrigin: "287.28px 145.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,152.56H140.76a.5.5,0,0,1,0-1H172V145H79.57v6.59H133a.5.5,0,1,1,0,1h-54a.5.5,0,0,1-.5-.5v-7.59a.5.5,0,0,1,.5-.5h93.45a.5.5,0,0,1,.5.5v7.59A.5.5,0,0,1,172.52,152.56Z",
    id: "elw44fji16alc",
    className: "animable",
    style: {
      transformOrigin: "125.725px 148.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,204.63a.51.51,0,0,1-.5-.5V152.07a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v52.06A.5.5,0,0,1,83.29,204.63Z",
    id: "el14za03fazwy",
    className: "animable",
    style: {
      transformOrigin: "83.29px 178.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.28,165.49a.5.5,0,0,1-.5-.5V152.46a.5.5,0,0,1,1,0V165A.5.5,0,0,1,169.28,165.49Z",
    id: "elq9gpvo6n47s",
    className: "animable",
    style: {
      transformOrigin: "169.28px 158.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27,274.58h-9.5a.5.5,0,0,1-.5-.5v-4.85h-9.6a.5.5,0,0,1-.5-.5V184.88H393.73V226a.5.5,0,0,1-.5.5h-8.31a.5.5,0,0,1,0-1h7.81V184.38a.5.5,0,0,1,.5-.5h56.44a.5.5,0,0,1,.5.5v83.85h9.6a.51.51,0,0,1,.5.5v4.85h8.5V241.41a.5.5,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-6.63v32.17A.5.5,0,0,1,469.27,274.58Z",
    id: "elag72agzt2h5",
    className: "animable",
    style: {
      transformOrigin: "430.66px 229.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,236H22a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h49.9a.5.5,0,0,1,.5.5A.5.5,0,0,1,71.85,236Z",
    id: "el0cie2s68l0k6",
    className: "animable",
    style: {
      transformOrigin: "46.95px 235.501px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.11,236H79a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h7.13a.5.5,0,0,1,.5.5A.5.5,0,0,1,86.11,236Z",
    id: "el43kxsgrmitn",
    className: "animable",
    style: {
      transformOrigin: "82.565px 235.5px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hospital-building--inject-2",
    className: "animable",
    style: {
      transformOrigin: "251.38px 303.665px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.03,
    y: 167.09,
    width: 231.39,
    height: 33.25,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "251.725px 183.715px"
    },
    id: "elyq8loxa017",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,200.84H136a.5.5,0,0,1-.5-.5V167.09a.5.5,0,0,1,.5-.5h231.4a.5.5,0,0,1,.5.5v33.25A.5.5,0,0,1,367.43,200.84Zm-230.9-1h230.4V167.59H136.53Z",
    id: "elj2wey2sugij",
    className: "animable",
    style: {
      transformOrigin: "251.7px 183.715px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.22,
    y: 167.09,
    width: 106.21,
    height: 33.25,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.325px 183.715px"
    },
    id: "el87q6qcjpc8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,200.84H261.22a.5.5,0,0,1-.5-.5V167.09a.5.5,0,0,1,.5-.5H367.43a.5.5,0,0,1,.5.5v33.25A.5.5,0,0,1,367.43,200.84Zm-105.71-1H366.93V167.59H261.72Z",
    id: "el0ybdi8qfuv1r",
    className: "animable",
    style: {
      transformOrigin: "314.325px 183.715px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.04,
    y: 197.06,
    width: 251.39,
    height: 7.72,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "251.735px 200.92px"
    },
    id: "elyxq5t3ztg6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.43,205.28H126a.5.5,0,0,1-.5-.5v-7.72a.5.5,0,0,1,.5-.5H377.43a.51.51,0,0,1,.5.5v7.72A.5.5,0,0,1,377.43,205.28Zm-250.89-1H376.93v-6.72H126.54Z",
    id: "el2cdtqdfs2l3",
    className: "animable",
    style: {
      transformOrigin: "251.715px 200.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.68,
    y: 202.13,
    width: 111.42,
    height: 238.11,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "320.39px 321.185px"
    },
    id: "elqmevemtx7vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,440.74H264.68a.5.5,0,0,1-.5-.5V202.13a.5.5,0,0,1,.5-.5H376.1a.5.5,0,0,1,.5.5V440.24A.5.5,0,0,1,376.1,440.74Zm-110.92-1H375.6V202.63H265.18Z",
    id: "elnw9526qij9",
    className: "animable",
    style: {
      transformOrigin: "320.39px 321.185px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.98,
    y: 213.84,
    width: 113.13,
    height: 5.95,
    id: "elu82getz7kzg",
    className: "animable",
    style: {
      transformOrigin: "319.545px 216.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.11,220.3H263a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5H376.11a.5.5,0,0,1,.5.5v6A.51.51,0,0,1,376.11,220.3Zm-112.63-1H375.61v-5H263.48Z",
    id: "el11l3fn7uk29l",
    className: "animable",
    style: {
      transformOrigin: "319.555px 216.8px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.98,
    y: 402.52,
    width: 113.13,
    height: 5.95,
    id: "el56n8teu9m9o",
    className: "animable",
    style: {
      transformOrigin: "319.545px 405.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.11,409H263a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5H376.11a.5.5,0,0,1,.5.5v6A.51.51,0,0,1,376.11,409Zm-112.63-1H375.61v-5H263.48Z",
    id: "el7lqlcjois4a",
    className: "animable",
    style: {
      transformOrigin: "319.555px 405.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.68,
    y: 202.13,
    width: 116.75,
    height: 13.63,
    style: {
      fill: "#96BBCE",
      transformOrigin: "323.055px 208.945px"
    },
    id: "el3dcnzjstmyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,216.26H264.18V201.63H381.92Zm-116.74-1H380.92V202.63H265.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.05px 208.945px"
    },
    id: "elhiifpkpmn3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.93,
    y: 202.13,
    width: 107.49,
    height: 13.63,
    style: {
      fill: "#96BBCE",
      transformOrigin: "327.675px 208.945px"
    },
    id: "elk3su6h58erf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,216.26H273.43V201.63H381.92Zm-107.49-1H380.92V202.63H274.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.675px 208.945px"
    },
    id: "eldqaf15v2e3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.68,
    y: 391.28,
    width: 116.75,
    height: 13.63,
    style: {
      fill: "#96BBCE",
      transformOrigin: "323.055px 398.095px"
    },
    id: "eleglq36hbeyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,405.41H264.18V390.78H381.92Zm-116.74-1H380.92V391.78H265.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.05px 398.095px"
    },
    id: "eloui8o3js97f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.74,
    y: 391.28,
    width: 108.68,
    height: 13.63,
    style: {
      fill: "#96BBCE",
      transformOrigin: "327.08px 398.095px"
    },
    id: "elbfgwk8s5djm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,405.41H272.24V390.78H381.92Zm-108.68-1H380.92V391.78H273.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.08px 398.095px"
    },
    id: "elb6qktw38qqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.67,
    y: 218.1,
    width: 45.38,
    height: 186.61,
    id: "el04uampgh3ok8",
    className: "animable",
    style: {
      transformOrigin: "147.36px 311.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,405.22H124.67a.51.51,0,0,1-.5-.5V218.1a.51.51,0,0,1,.5-.5h45.38a.5.5,0,0,1,.5.5V404.72A.5.5,0,0,1,170.05,405.22Zm-44.88-1h44.38V218.6H125.17Z",
    id: "elhpiczklt80t",
    className: "animable",
    style: {
      transformOrigin: "147.36px 311.41px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 202.13 121.34 223.2 174.68 223.2 174.68 242.15 121.34 242.15 121.34 262.09 174.68 262.09 174.68 281.04 121.34 281.04 121.34 300.99 174.68 300.99 174.68 319.94 121.34 319.94 121.34 339.89 174.68 339.89 174.68 358.84 121.34 358.84 121.34 378.79 174.68 378.79 174.68 397.74 121.34 397.74 121.34 440.24 210.19 440.24 210.19 202.13 121.34 202.13",
    style: {
      fill: "#96BBCE",
      transformOrigin: "165.765px 321.185px"
    },
    id: "elxf49jmzsu1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69,440.74H120.84V397.23h53.34V379.29H120.84v-21h53.34V340.39H120.84V319.44h53.34V301.49H120.84V280.54h53.34v-18H120.84V241.65h53.34v-18H120.84V201.63h89.85Zm-88.85-1h87.85V202.63H121.84V222.7h53.34v20H121.84v18.94h53.34v20H121.84v18.95h53.34v19.95H121.84v18.95h53.34v19.95H121.84v19h53.34v19.94H121.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.765px 321.185px"
    },
    id: "elxbtyq62gv6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.45,
    y: 202.13,
    width: 88.85,
    height: 238.11,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "220.875px 321.185px"
    },
    id: "eld7wrbpaihhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,440.74H176.45a.5.5,0,0,1-.5-.5V202.13a.5.5,0,0,1,.5-.5H265.3a.5.5,0,0,1,.5.5V440.24A.5.5,0,0,1,265.3,440.74Zm-88.35-1H264.8V202.63H177Z",
    id: "elx7fsvq9u2ve",
    className: "animable",
    style: {
      transformOrigin: "220.875px 321.185px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.26,
    y: 202.13,
    width: 88.85,
    height: 238.11,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "210.685px 321.185px"
    },
    id: "elac9l5cxj6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.11,440.74H166.26a.5.5,0,0,1-.5-.5V202.13a.5.5,0,0,1,.5-.5h88.85a.5.5,0,0,1,.5.5V440.24A.5.5,0,0,1,255.11,440.74Zm-88.35-1h87.85V202.63H166.76Z",
    id: "elwnyteldxeqi",
    className: "animable",
    style: {
      transformOrigin: "210.685px 321.185px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.49,
    y: 212.86,
    width: 47.29,
    height: 47.29,
    style: {
      fill: "#96BBCE",
      transformOrigin: "211.135px 236.505px"
    },
    id: "elf206f7jomjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,260.64H187V212.36h48.29Zm-47.29-1h46.29V213.36H188Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.145px 236.5px"
    },
    id: "elokqphkelsjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 223.6,
    width: 15.44,
    height: 16.7,
    id: "el42sic84c4qf",
    className: "animable",
    style: {
      transformOrigin: "276.44px 231.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,240.81H268.72a.5.5,0,0,1-.5-.5V223.6a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,284.16,240.81Zm-14.94-1h14.44V224.1H269.22Z",
    id: "elnlfngk9jjj8",
    className: "animable",
    style: {
      transformOrigin: "276.44px 231.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 223.6,
    width: 15.44,
    height: 16.7,
    id: "elzqtd11giom",
    className: "animable",
    style: {
      transformOrigin: "298.15px 231.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,240.81H290.43a.51.51,0,0,1-.5-.5V223.6a.5.5,0,0,1,.5-.5h15.45a.5.5,0,0,1,.5.5v16.71A.51.51,0,0,1,305.88,240.81Zm-14.95-1h14.45V224.1H290.93Z",
    id: "elsa2vgwgejh",
    className: "animable",
    style: {
      transformOrigin: "298.155px 231.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 223.6,
    width: 15.44,
    height: 16.7,
    id: "el85dzgro5uew",
    className: "animable",
    style: {
      transformOrigin: "319.87px 231.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,240.81H312.15a.5.5,0,0,1-.5-.5V223.6a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,327.59,240.81Zm-14.94-1h14.44V224.1H312.65Z",
    id: "elzzmcno6s6tk",
    className: "animable",
    style: {
      transformOrigin: "319.87px 231.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 223.6,
    width: 15.44,
    height: 16.7,
    id: "elq2rhilv7dei",
    className: "animable",
    style: {
      transformOrigin: "341.58px 231.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,240.81H333.86a.51.51,0,0,1-.5-.5V223.6a.5.5,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,349.3,240.81Zm-14.94-1H348.8V224.1H334.36Z",
    id: "elwv4yyolp6al",
    className: "animable",
    style: {
      transformOrigin: "341.58px 231.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 223.6,
    width: 15.44,
    height: 16.7,
    id: "el7nvrjmojh6f",
    className: "animable",
    style: {
      transformOrigin: "363.29px 231.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,240.81H355.57a.51.51,0,0,1-.5-.5V223.6a.5.5,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,371,240.81Zm-14.94-1h14.44V224.1H356.07Z",
    id: "elsi7v9pfiyii",
    className: "animable",
    style: {
      transformOrigin: "363.285px 231.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 252.7,
    width: 15.44,
    height: 16.7,
    id: "eli1wzaqjckll",
    className: "animable",
    style: {
      transformOrigin: "276.44px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,269.9H268.72a.5.5,0,0,1-.5-.5V252.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,284.16,269.9Zm-14.94-1h14.44V253.2H269.22Z",
    id: "elw2ga15oegtp",
    className: "animable",
    style: {
      transformOrigin: "276.44px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 252.7,
    width: 15.44,
    height: 16.7,
    id: "elfuvao70afbu",
    className: "animable",
    style: {
      transformOrigin: "298.15px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,269.9H290.43a.5.5,0,0,1-.5-.5V252.7a.5.5,0,0,1,.5-.5h15.45a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,305.88,269.9Zm-14.95-1h14.45V253.2H290.93Z",
    id: "elky4fbmqlsi",
    className: "animable",
    style: {
      transformOrigin: "298.155px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 252.7,
    width: 15.44,
    height: 16.7,
    id: "eltco3ekbbnyr",
    className: "animable",
    style: {
      transformOrigin: "319.87px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,269.9H312.15a.5.5,0,0,1-.5-.5V252.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,327.59,269.9Zm-14.94-1h14.44V253.2H312.65Z",
    id: "elbp2cwgl1ut4",
    className: "animable",
    style: {
      transformOrigin: "319.87px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 252.7,
    width: 15.44,
    height: 16.7,
    id: "el02exms9bihe3",
    className: "animable",
    style: {
      transformOrigin: "341.58px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,269.9H333.86a.5.5,0,0,1-.5-.5V252.7a.5.5,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,349.3,269.9Zm-14.94-1H348.8V253.2H334.36Z",
    id: "elvx1oxlrs4ib",
    className: "animable",
    style: {
      transformOrigin: "341.58px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 252.7,
    width: 15.44,
    height: 16.7,
    id: "el600nbdjlbwl",
    className: "animable",
    style: {
      transformOrigin: "363.29px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,269.9H355.57a.5.5,0,0,1-.5-.5V252.7a.5.5,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,371,269.9Zm-14.94-1h14.44V253.2H356.07Z",
    id: "el61i5b4fuwwy",
    className: "animable",
    style: {
      transformOrigin: "363.285px 261.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 281.79,
    width: 15.44,
    height: 16.7,
    id: "elb1l98b6au7h",
    className: "animable",
    style: {
      transformOrigin: "276.44px 290.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,299H268.72a.5.5,0,0,1-.5-.5V281.79a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5V298.5A.5.5,0,0,1,284.16,299Zm-14.94-1h14.44V282.29H269.22Z",
    id: "elqsipmxl8agm",
    className: "animable",
    style: {
      transformOrigin: "276.44px 290.145px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 281.79,
    width: 15.44,
    height: 16.7,
    id: "eljmkv4gpctlp",
    className: "animable",
    style: {
      transformOrigin: "298.15px 290.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,299H290.43a.51.51,0,0,1-.5-.5V281.79a.5.5,0,0,1,.5-.5h15.45a.5.5,0,0,1,.5.5V298.5A.51.51,0,0,1,305.88,299Zm-14.95-1h14.45V282.29H290.93Z",
    id: "els5sqw98neb",
    className: "animable",
    style: {
      transformOrigin: "298.155px 290.145px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 281.79,
    width: 15.44,
    height: 16.7,
    id: "elk8pg4ptkth",
    className: "animable",
    style: {
      transformOrigin: "319.87px 290.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,299H312.15a.5.5,0,0,1-.5-.5V281.79a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5V298.5A.5.5,0,0,1,327.59,299Zm-14.94-1h14.44V282.29H312.65Z",
    id: "elu2u54mbkz9n",
    className: "animable",
    style: {
      transformOrigin: "319.87px 290.145px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 281.79,
    width: 15.44,
    height: 16.7,
    id: "elzscbqgool9a",
    className: "animable",
    style: {
      transformOrigin: "341.58px 290.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,299H333.86a.51.51,0,0,1-.5-.5V281.79a.5.5,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5V298.5A.5.5,0,0,1,349.3,299Zm-14.94-1H348.8V282.29H334.36Z",
    id: "elgnx5zt5n8rf",
    className: "animable",
    style: {
      transformOrigin: "341.58px 290.145px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 281.79,
    width: 15.44,
    height: 16.7,
    id: "elou1khqvntae",
    className: "animable",
    style: {
      transformOrigin: "363.29px 290.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,299H355.57a.51.51,0,0,1-.5-.5V281.79a.5.5,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5V298.5A.5.5,0,0,1,371,299Zm-14.94-1h14.44V282.29H356.07Z",
    id: "ellj4vif5rxtk",
    className: "animable",
    style: {
      transformOrigin: "363.285px 290.145px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 310.89,
    width: 15.44,
    height: 16.7,
    id: "elocn040t31ul",
    className: "animable",
    style: {
      transformOrigin: "276.44px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,328.09H268.72a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,284.16,328.09Zm-14.94-1h14.44v-15.7H269.22Z",
    id: "elogqdpn5c72g",
    className: "animable",
    style: {
      transformOrigin: "276.44px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 310.89,
    width: 15.44,
    height: 16.7,
    id: "el50859p7dzk5",
    className: "animable",
    style: {
      transformOrigin: "298.15px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,328.09H290.43a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.45a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,305.88,328.09Zm-14.95-1h14.45v-15.7H290.93Z",
    id: "elwdz782mm6u",
    className: "animable",
    style: {
      transformOrigin: "298.155px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 310.89,
    width: 15.44,
    height: 16.7,
    id: "el42o8rl90qnu",
    className: "animable",
    style: {
      transformOrigin: "319.87px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,328.09H312.15a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,327.59,328.09Zm-14.94-1h14.44v-15.7H312.65Z",
    id: "el2xzj3yypapr",
    className: "animable",
    style: {
      transformOrigin: "319.87px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 310.89,
    width: 15.44,
    height: 16.7,
    id: "elmvp4r82ws7",
    className: "animable",
    style: {
      transformOrigin: "341.58px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,328.09H333.86a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,349.3,328.09Zm-14.94-1H348.8v-15.7H334.36Z",
    id: "elg2ids13unf",
    className: "animable",
    style: {
      transformOrigin: "341.58px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 310.89,
    width: 15.44,
    height: 16.7,
    id: "el3ydshh3zgxl",
    className: "animable",
    style: {
      transformOrigin: "363.29px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,328.09H355.57a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,371,328.09Zm-14.94-1h14.44v-15.7H356.07Z",
    id: "elwje3yp8jk3a",
    className: "animable",
    style: {
      transformOrigin: "363.285px 319.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 339.98,
    width: 15.44,
    height: 16.7,
    id: "elsri6gxy0agm",
    className: "animable",
    style: {
      transformOrigin: "276.44px 348.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,357.19H268.72a.5.5,0,0,1-.5-.5V340a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,284.16,357.19Zm-14.94-1h14.44V340.48H269.22Z",
    id: "ellvxrot454zg",
    className: "animable",
    style: {
      transformOrigin: "276.44px 348.345px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 339.98,
    width: 15.44,
    height: 16.7,
    id: "eldyxd6lqcdgp",
    className: "animable",
    style: {
      transformOrigin: "298.15px 348.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,357.19H290.43a.51.51,0,0,1-.5-.5V340a.51.51,0,0,1,.5-.5h15.45a.51.51,0,0,1,.5.5v16.71A.51.51,0,0,1,305.88,357.19Zm-14.95-1h14.45V340.48H290.93Z",
    id: "elnej1mesr48",
    className: "animable",
    style: {
      transformOrigin: "298.155px 348.345px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 339.98,
    width: 15.44,
    height: 16.7,
    id: "elibs02l12g5o",
    className: "animable",
    style: {
      transformOrigin: "319.87px 348.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,357.19H312.15a.5.5,0,0,1-.5-.5V340a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,327.59,357.19Zm-14.94-1h14.44V340.48H312.65Z",
    id: "elfl3ctogoror",
    className: "animable",
    style: {
      transformOrigin: "319.87px 348.345px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 339.98,
    width: 15.44,
    height: 16.7,
    id: "ele1q1jitc8za",
    className: "animable",
    style: {
      transformOrigin: "341.58px 348.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,357.19H333.86a.51.51,0,0,1-.5-.5V340a.51.51,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,349.3,357.19Zm-14.94-1H348.8V340.48H334.36Z",
    id: "elwi1r9yejksn",
    className: "animable",
    style: {
      transformOrigin: "341.58px 348.345px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 339.98,
    width: 15.44,
    height: 16.7,
    id: "elalkxqb6pzae",
    className: "animable",
    style: {
      transformOrigin: "363.29px 348.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,357.19H355.57a.51.51,0,0,1-.5-.5V340a.51.51,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5v16.71A.5.5,0,0,1,371,357.19Zm-14.94-1h14.44V340.48H356.07Z",
    id: "el4roj9g4c0a",
    className: "animable",
    style: {
      transformOrigin: "363.285px 348.345px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.72,
    y: 369.08,
    width: 15.44,
    height: 16.7,
    id: "eldy2yijtn6u",
    className: "animable",
    style: {
      transformOrigin: "276.44px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,386.28H268.72a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,284.16,386.28Zm-14.94-1h14.44v-15.7H269.22Z",
    id: "elkxrbrashh9",
    className: "animable",
    style: {
      transformOrigin: "276.44px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 369.08,
    width: 15.44,
    height: 16.7,
    id: "el4vl40y7w8w9",
    className: "animable",
    style: {
      transformOrigin: "298.15px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.88,386.28H290.43a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.45a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,305.88,386.28Zm-14.95-1h14.45v-15.7H290.93Z",
    id: "elsxle0vvcu4h",
    className: "animable",
    style: {
      transformOrigin: "298.155px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.15,
    y: 369.08,
    width: 15.44,
    height: 16.7,
    id: "ellp5n0o59w8d",
    className: "animable",
    style: {
      transformOrigin: "319.87px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,386.28H312.15a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5h15.44a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,327.59,386.28Zm-14.94-1h14.44v-15.7H312.65Z",
    id: "elejlekxf1b7",
    className: "animable",
    style: {
      transformOrigin: "319.87px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.86,
    y: 369.08,
    width: 15.44,
    height: 16.7,
    id: "elyqqc1cvt86",
    className: "animable",
    style: {
      transformOrigin: "341.58px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,386.28H333.86a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5H349.3a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,349.3,386.28Zm-14.94-1H348.8v-15.7H334.36Z",
    id: "elfw8nu41xyjj",
    className: "animable",
    style: {
      transformOrigin: "341.58px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.57,
    y: 369.08,
    width: 15.44,
    height: 16.7,
    id: "ellvvr3c3z3w",
    className: "animable",
    style: {
      transformOrigin: "363.29px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,386.28H355.57a.5.5,0,0,1-.5-.5v-16.7a.5.5,0,0,1,.5-.5H371a.5.5,0,0,1,.5.5v16.7A.5.5,0,0,1,371,386.28Zm-14.94-1h14.44v-15.7H356.07Z",
    id: "elv3801j2ld6s",
    className: "animable",
    style: {
      transformOrigin: "363.285px 377.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 413.23,
    width: 20.37,
    height: 27.01,
    id: "elep3i8dph9y",
    className: "animable",
    style: {
      transformOrigin: "284.285px 426.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.46,440.74H274.1a.5.5,0,0,1-.5-.5v-27a.5.5,0,0,1,.5-.5h20.36a.5.5,0,0,1,.5.5v27A.5.5,0,0,1,294.46,440.74Zm-19.86-1H294v-26H274.6Z",
    id: "elv28pncfxm7g",
    className: "animable",
    style: {
      transformOrigin: "284.28px 426.74px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.82,
    y: 413.23,
    width: 20.37,
    height: 27.01,
    id: "el0dr41nu9zruv",
    className: "animable",
    style: {
      transformOrigin: "358.005px 426.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.19,440.74H347.82a.5.5,0,0,1-.5-.5v-27a.5.5,0,0,1,.5-.5h20.37a.5.5,0,0,1,.5.5v27A.5.5,0,0,1,368.19,440.74Zm-19.87-1h19.37v-26H348.32Z",
    id: "elpplu2etv9yj",
    className: "animable",
    style: {
      transformOrigin: "358.005px 426.74px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.8,
    y: 413.23,
    width: 38.75,
    height: 27.01,
    id: "el39pqe7b5yzv",
    className: "animable",
    style: {
      transformOrigin: "321.175px 426.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,440.74H301.8a.5.5,0,0,1-.5-.5v-27a.5.5,0,0,1,.5-.5h38.74a.5.5,0,0,1,.5.5v27A.5.5,0,0,1,340.54,440.74Zm-38.24-1H340v-26H302.3Z",
    id: "el5uu2afwksn",
    className: "animable",
    style: {
      transformOrigin: "321.17px 426.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.56,254.62V218.38h7.38v14.9h6.4v-14.9h7.38v36.24h-7.38V238.56h-6.4v16.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.14px 236.5px"
    },
    id: "elz2qlxr32l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.62,
    y: 268.35,
    width: 45.84,
    height: 150.89,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "211.54px 343.795px"
    },
    id: "elalih6unw3x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.46,419.74H188.62a.5.5,0,0,1-.5-.5V268.35a.5.5,0,0,1,.5-.5h45.84a.5.5,0,0,1,.5.5V419.24A.5.5,0,0,1,234.46,419.74Zm-45.34-1H234V268.85H189.12Z",
    id: "eljy0e6q8hqag",
    className: "animable",
    style: {
      transformOrigin: "211.54px 343.795px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,419.69a.5.5,0,0,1-.5-.5V268.76a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V419.19A.5.5,0,0,1,211.26,419.69Z",
    id: "elv03w2g2qatk",
    className: "animable",
    style: {
      transformOrigin: "211.26px 343.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,285.7H188.82a.5.5,0,0,1,0-1H234a.5.5,0,0,1,0,1Z",
    id: "elmhu4q0voaor",
    className: "animable",
    style: {
      transformOrigin: "211.41px 285.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,303H188.82a.5.5,0,0,1,0-1H234a.5.5,0,1,1,0,1Z",
    id: "el6uopvn140y",
    className: "animable",
    style: {
      transformOrigin: "211.41px 302.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,320.24H188.82a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H234a.5.5,0,0,1,.5.5A.5.5,0,0,1,234,320.24Z",
    id: "elrn6tzbydsf",
    className: "animable",
    style: {
      transformOrigin: "211.41px 319.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,337.51H188.82a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H234a.5.5,0,0,1,.5.5A.5.5,0,0,1,234,337.51Z",
    id: "eltmn2ywyhdo",
    className: "animable",
    style: {
      transformOrigin: "211.41px 337.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,354.77H188.82a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H234a.5.5,0,0,1,.5.5A.5.5,0,0,1,234,354.77Z",
    id: "elke253mu9hpd",
    className: "animable",
    style: {
      transformOrigin: "211.41px 354.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,372H188.82a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H234a.5.5,0,0,1,.5.5A.5.5,0,0,1,234,372Z",
    id: "ely8l51nvhgo",
    className: "animable",
    style: {
      transformOrigin: "211.41px 371.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,389.31H188.82a.5.5,0,0,1,0-1H234a.5.5,0,0,1,0,1Z",
    id: "elzro7jtsyjzq",
    className: "animable",
    style: {
      transformOrigin: "211.41px 388.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,406.58H188.82a.5.5,0,0,1,0-1H234a.5.5,0,0,1,0,1Z",
    id: "el2szatw0hpib",
    className: "animable",
    style: {
      transformOrigin: "211.41px 406.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,281.46a.5.5,0,0,1-.35-.85l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.41A.51.51,0,0,1,197.07,281.46Z",
    id: "elwcyovayn71e",
    className: "animable",
    style: {
      transformOrigin: "201.782px 276.254px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,280a.51.51,0,0,1-.36-.15.51.51,0,0,1,0-.71l3.28-3.27a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-3.28,3.27A.5.5,0,0,1,193.94,280Z",
    id: "elu8wmb8qe6fk",
    className: "animable",
    style: {
      transformOrigin: "195.575px 277.861px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,299.2a.5.5,0,0,1-.35-.15.51.51,0,0,1,0-.71l9.42-9.41a.48.48,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.41A.51.51,0,0,1,197.07,299.2Z",
    id: "elljn7poq5xb",
    className: "animable",
    style: {
      transformOrigin: "201.782px 293.989px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,297.7a.51.51,0,0,1-.36-.15.51.51,0,0,1,0-.71l3.28-3.27a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-3.28,3.27A.5.5,0,0,1,193.94,297.7Z",
    id: "el1b9ur9bhxdr",
    className: "animable",
    style: {
      transformOrigin: "195.575px 295.561px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,316.94a.5.5,0,0,1-.35-.15.51.51,0,0,1,0-.71l9.42-9.41a.49.49,0,1,1,.7.7l-9.41,9.42A.51.51,0,0,1,197.07,316.94Z",
    id: "elzun621iihcr",
    className: "animable",
    style: {
      transformOrigin: "201.781px 311.733px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,315.43a.5.5,0,0,1-.36-.14.51.51,0,0,1,0-.71l3.28-3.27a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.7l-3.28,3.28A.49.49,0,0,1,193.94,315.43Z",
    id: "el7yquwmyhj93",
    className: "animable",
    style: {
      transformOrigin: "195.575px 313.296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,333.58a.54.54,0,0,1-.35-.14.51.51,0,0,1,0-.71l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,197.07,333.58Z",
    id: "eltqv3bu8y8nn",
    className: "animable",
    style: {
      transformOrigin: "201.782px 328.374px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,332.08a.54.54,0,0,1-.36-.14.51.51,0,0,1,0-.71l3.28-3.28a.5.5,0,1,1,.71.71l-3.28,3.28A.54.54,0,0,1,193.94,332.08Z",
    id: "elk4x4bbd351",
    className: "animable",
    style: {
      transformOrigin: "195.577px 329.941px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,351.05a.5.5,0,0,1-.35-.85l9.42-9.42a.48.48,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.41A.51.51,0,0,1,197.07,351.05Z",
    id: "eltpcnm3boy5",
    className: "animable",
    style: {
      transformOrigin: "201.782px 345.839px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,349.55a.51.51,0,0,1-.36-.15.51.51,0,0,1,0-.71l3.28-3.27a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-3.28,3.27A.5.5,0,0,1,193.94,349.55Z",
    id: "el3t6mkxi16qt",
    className: "animable",
    style: {
      transformOrigin: "195.575px 347.411px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,367.42a.54.54,0,0,1-.35-.14.51.51,0,0,1,0-.71l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,197.07,367.42Z",
    id: "elfvtu7ay16gp",
    className: "animable",
    style: {
      transformOrigin: "201.782px 362.214px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,365.92a.54.54,0,0,1-.36-.14.51.51,0,0,1,0-.71l3.28-3.28a.5.5,0,1,1,.71.71l-3.28,3.28A.54.54,0,0,1,193.94,365.92Z",
    id: "elzvkx99bj72s",
    className: "animable",
    style: {
      transformOrigin: "195.577px 363.781px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,385.16a.5.5,0,0,1-.35-.85l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71L197.43,385A.51.51,0,0,1,197.07,385.16Z",
    id: "elt7rx9diaz8q",
    className: "animable",
    style: {
      transformOrigin: "201.782px 379.954px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,383.66a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l3.28-3.28a.5.5,0,1,1,.71.71l-3.28,3.27A.5.5,0,0,1,193.94,383.66Z",
    id: "eltyqdzsoc7j",
    className: "animable",
    style: {
      transformOrigin: "195.578px 381.521px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,403.17a.54.54,0,0,1-.35-.14.51.51,0,0,1,0-.71l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71L197.43,403A.54.54,0,0,1,197.07,403.17Z",
    id: "el4e5wlicfh1o",
    className: "animable",
    style: {
      transformOrigin: "201.782px 397.964px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,401.67a.54.54,0,0,1-.36-.14.51.51,0,0,1,0-.71l3.28-3.28a.5.5,0,1,1,.71.71l-3.28,3.28A.54.54,0,0,1,193.94,401.67Z",
    id: "elkdug5jvsy3l",
    className: "animable",
    style: {
      transformOrigin: "195.577px 399.531px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,417.36a.54.54,0,0,1-.35-.14.51.51,0,0,1,0-.71l9.42-9.42a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,197.07,417.36Z",
    id: "elcjpwgj175g",
    className: "animable",
    style: {
      transformOrigin: "201.782px 412.154px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,415.86a.54.54,0,0,1-.36-.14.51.51,0,0,1,0-.71l3.28-3.28a.5.5,0,0,1,.71.71l-3.28,3.28A.54.54,0,0,1,193.94,415.86Z",
    id: "el99achco69s",
    className: "animable",
    style: {
      transformOrigin: "195.577px 413.721px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,281.46a.5.5,0,0,1-.35-.85l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-9.41,9.41A.51.51,0,0,1,218.81,281.46Z",
    id: "elgumsmbce4rd",
    className: "animable",
    style: {
      transformOrigin: "223.522px 276.253px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,280a.5.5,0,0,1-.35-.15.5.5,0,0,1,0-.71l3.27-3.27a.5.5,0,0,1,.71.71L216,279.81A.51.51,0,0,1,215.67,280Z",
    id: "elvy4ijcmto59",
    className: "animable",
    style: {
      transformOrigin: "217.31px 277.861px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,299.2a.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71l9.41-9.41a.5.5,0,1,1,.71.71l-9.41,9.41A.51.51,0,0,1,218.81,299.2Z",
    id: "el9n00s7dzn3o",
    className: "animable",
    style: {
      transformOrigin: "223.52px 293.992px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,297.7a.5.5,0,0,1-.35-.15.5.5,0,0,1,0-.71l3.27-3.27a.5.5,0,1,1,.71.71L216,297.55A.51.51,0,0,1,215.67,297.7Z",
    id: "elzh0tbybe72",
    className: "animable",
    style: {
      transformOrigin: "217.31px 295.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,316.94a.49.49,0,0,1-.35-.15.5.5,0,0,1,0-.71l9.41-9.41a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-9.41,9.42A.51.51,0,0,1,218.81,316.94Z",
    id: "elydsxe49xnzr",
    className: "animable",
    style: {
      transformOrigin: "223.522px 311.731px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,315.43a.5.5,0,0,1-.35-.85l3.27-3.27a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7L216,315.29A.5.5,0,0,1,215.67,315.43Z",
    id: "el7ku426ihy0a",
    className: "animable",
    style: {
      transformOrigin: "217.314px 313.296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,333.58a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,218.81,333.58Z",
    id: "elwxcb2xv21k",
    className: "animable",
    style: {
      transformOrigin: "223.52px 328.373px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,332.08a.54.54,0,0,1-.35-.14.5.5,0,0,1,0-.71l3.27-3.28a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L216,331.94A.54.54,0,0,1,215.67,332.08Z",
    id: "elwf21yqwtc29",
    className: "animable",
    style: {
      transformOrigin: "217.31px 329.943px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,351.05a.5.5,0,0,1-.35-.85l9.41-9.42a.5.5,0,1,1,.71.71l-9.41,9.41A.51.51,0,0,1,218.81,351.05Z",
    id: "eldrtbty16em",
    className: "animable",
    style: {
      transformOrigin: "223.523px 345.841px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,349.55a.5.5,0,0,1-.35-.15.5.5,0,0,1,0-.71l3.27-3.27a.5.5,0,1,1,.71.71L216,349.4A.51.51,0,0,1,215.67,349.55Z",
    id: "el353mmwaoyzf",
    className: "animable",
    style: {
      transformOrigin: "217.31px 347.411px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,367.42a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,218.81,367.42Z",
    id: "elor2d92r41p",
    className: "animable",
    style: {
      transformOrigin: "223.52px 362.213px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,365.92a.54.54,0,0,1-.35-.14.5.5,0,0,1,0-.71l3.27-3.28a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L216,365.78A.54.54,0,0,1,215.67,365.92Z",
    id: "elwynv8l4jkue",
    className: "animable",
    style: {
      transformOrigin: "217.31px 363.783px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,385.16a.5.5,0,0,1-.35-.85l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L219.17,385A.51.51,0,0,1,218.81,385.16Z",
    id: "el0nfyxx5wa4va",
    className: "animable",
    style: {
      transformOrigin: "223.522px 379.953px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,383.66a.5.5,0,0,1-.35-.15.48.48,0,0,1,0-.7l3.27-3.28a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L216,383.51A.51.51,0,0,1,215.67,383.66Z",
    id: "ell70heulpp4",
    className: "animable",
    style: {
      transformOrigin: "217.308px 381.523px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,403.17a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L219.17,403A.54.54,0,0,1,218.81,403.17Z",
    id: "el2l9gfaw7m6g",
    className: "animable",
    style: {
      transformOrigin: "223.52px 397.963px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,401.67a.54.54,0,0,1-.35-.14.5.5,0,0,1,0-.71l3.27-3.28a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L216,401.53A.54.54,0,0,1,215.67,401.67Z",
    id: "el3lff412zu8q",
    className: "animable",
    style: {
      transformOrigin: "217.31px 399.533px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,417.36a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71l9.41-9.42a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-9.41,9.42A.54.54,0,0,1,218.81,417.36Z",
    id: "elgp17ugj36f",
    className: "animable",
    style: {
      transformOrigin: "223.52px 412.153px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,415.86a.54.54,0,0,1-.35-.14.5.5,0,0,1,0-.71l3.27-3.28a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L216,415.72A.54.54,0,0,1,215.67,415.86Z",
    id: "elvtqxolgrhq",
    className: "animable",
    style: {
      transformOrigin: "217.31px 413.723px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,192.29V172.22h4.09v8.25h3.54v-8.25h4.09v20.07h-4.09v-8.9h-3.54v8.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.99px 182.255px"
    },
    id: "elk3jwghmfih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,192.56a6.74,6.74,0,0,1-3.5-.79,4.41,4.41,0,0,1-1.84-2.27,10,10,0,0,1-.56-3.53v-7.48a9.92,9.92,0,0,1,.56-3.52,4.28,4.28,0,0,1,1.84-2.23,8.36,8.36,0,0,1,7,0,4.38,4.38,0,0,1,1.85,2.23,9.64,9.64,0,0,1,.56,3.51V186a9.79,9.79,0,0,1-.56,3.53,4.43,4.43,0,0,1-1.85,2.27A6.86,6.86,0,0,1,289.55,192.56Zm0-2.95a1.63,1.63,0,0,0,1.16-.36,1.85,1.85,0,0,0,.5-1,6.79,6.79,0,0,0,.12-1.31V177.5a6.43,6.43,0,0,0-.12-1.29,1.85,1.85,0,0,0-.5-1,1.68,1.68,0,0,0-1.16-.35,1.6,1.6,0,0,0-1.12.35,1.77,1.77,0,0,0-.49,1,5.75,5.75,0,0,0-.13,1.29V187a7.71,7.71,0,0,0,.11,1.31,1.77,1.77,0,0,0,.49,1A1.56,1.56,0,0,0,289.55,189.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "289.555px 182.27px"
    },
    id: "el4nfqeoz8z4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42,192.56a6.43,6.43,0,0,1-3.1-.68,4.37,4.37,0,0,1-1.87-2.06,9.55,9.55,0,0,1-.73-3.5l3.52-.6a10,10,0,0,0,.26,2.07,2.51,2.51,0,0,0,.64,1.24,1.53,1.53,0,0,0,1.08.41,1.14,1.14,0,0,0,1.08-.5,2.24,2.24,0,0,0,.28-1.14,3.61,3.61,0,0,0-.6-2.12,10.44,10.44,0,0,0-1.6-1.72l-2.08-1.81a8.18,8.18,0,0,1-1.82-2.13,5.61,5.61,0,0,1-.71-2.92,4.87,4.87,0,0,1,1.45-3.8,5.65,5.65,0,0,1,4-1.33,5.4,5.4,0,0,1,2.47.5,3.73,3.73,0,0,1,1.5,1.32,5.43,5.43,0,0,1,.75,1.81,13,13,0,0,1,.26,2l-3.5.52a13.46,13.46,0,0,0-.16-1.61,2.14,2.14,0,0,0-.44-1.09,1.24,1.24,0,0,0-1-.4,1.18,1.18,0,0,0-1.06.53,2.15,2.15,0,0,0-.35,1.18,3,3,0,0,0,.48,1.75,9.41,9.41,0,0,0,1.33,1.42l2,1.78a11.7,11.7,0,0,1,2.17,2.49,6.3,6.3,0,0,1,.9,3.46,5.08,5.08,0,0,1-.64,2.55,4.53,4.53,0,0,1-1.8,1.78A5.46,5.46,0,0,1,303.42,192.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "303.147px 182.262px"
    },
    id: "el4uw3ydpxryy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,192.29V172.22h6.36a5.72,5.72,0,0,1,3,.68,4.16,4.16,0,0,1,1.7,2A7.88,7.88,0,0,1,322,178a6.51,6.51,0,0,1-.73,3.37,4,4,0,0,1-2,1.72,7.7,7.7,0,0,1-2.9.51h-1.86v8.7Zm4.08-11.57h1.44a2.78,2.78,0,0,0,1.38-.29,1.43,1.43,0,0,0,.65-.9,5.8,5.8,0,0,0,.18-1.59,7.25,7.25,0,0,0-.14-1.53,1.53,1.53,0,0,0-.61-1,2.53,2.53,0,0,0-1.49-.35h-1.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.21px 182.257px"
    },
    id: "elwfz08jrjogp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,192.29V172.22H328v20.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326px 182.255px"
    },
    id: "eli4g7ofcnqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,192.29v-17h-3.1v-3.05h10.26v3.05h-3.05v17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.03px 182.265px"
    },
    id: "el8bau34sd0z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.26,192.29l3.89-20.07h4.53l3.86,20.07h-3.79l-.71-4.41h-3.18l-.76,4.41Zm5-6.92h2.4l-1.21-8.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.4px 182.255px"
    },
    id: "elstq05sx5x5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,192.29V172.22h4.09v17.29h4.7v2.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.825px 182.255px"
    },
    id: "elrmvlhbic1z",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2",
    className: "animable",
    style: {
      transformOrigin: "265.54px 375.25px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.9,376.83c0,15.11-8.93,27.36-20,27.36s-20-12.25-20-27.36,8.93-67,20-67S109.9,361.72,109.9,376.83Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "89.9px 357.01px"
    },
    id: "elhz7sy5f7atd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.13 384.74 95.09 386.97 96.3 383.33 93.41 387.59 90.53 388.66 90.32 376.71 100.82 362.76 95.19 368.39 96.15 364.47 93.45 370.13 90.26 373.32 89.94 354.65 88.8 381.88 78.84 371.33 84.31 378.76 79.16 378.19 85.52 380.41 88.68 384.7 88.13 397.83 84.45 395.34 88.01 400.54 86.33 440.67 91.42 440.67 90.56 390.57 101.13 384.74",
    id: "el199l3v6f7o3",
    className: "animable",
    style: {
      transformOrigin: "89.985px 397.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92,354.71a5.05,5.05,0,0,1-.82,3.18,5.1,5.1,0,0,1-2.81,1.69,4.33,4.33,0,0,1,3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "99.0926px 357.145px"
    },
    id: "elwaq3paqsnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94,363.16a4.35,4.35,0,0,1-3.63,4.88,4.35,4.35,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "105.125px 365.6px"
    },
    id: "elmbrfz0e3uam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94,379.62a4.34,4.34,0,0,1-5.06,3.37,4.34,4.34,0,0,1,5.06-3.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "104.41px 381.305px"
    },
    id: "elsmb9kqdncve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89,379.62A4.34,4.34,0,0,0,79,383a4.34,4.34,0,0,0-5.06-3.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.445px 381.32px"
    },
    id: "elxlhhvx4oze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,372.79a4.35,4.35,0,0,1-3.63,4.88,4.31,4.31,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "98.1825px 375.23px"
    },
    id: "el28dmq3l9zab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,345.51a4.35,4.35,0,0,1-3.63,4.88,4.35,4.35,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.615px 347.95px"
    },
    id: "eljiyftdg12ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,352.53a5.09,5.09,0,0,1-.81,3.18,5.15,5.15,0,0,1-2.82,1.69,5.13,5.13,0,0,1,.82-3.18A5,5,0,0,1,94.84,352.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "93.026px 354.965px"
    },
    id: "elbuuwwy0hfqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.35,347.42a4.31,4.31,0,0,1-3.63,4.87,4.33,4.33,0,0,1,3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.536px 349.855px"
    },
    id: "elk75p662udvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,347.42a4.33,4.33,0,0,0,3.63,4.87,4.33,4.33,0,0,0-3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "77.515px 349.855px"
    },
    id: "eliiqzh4m8ie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.21,336.94a4.33,4.33,0,0,1-3.63,4.87,5.05,5.05,0,0,1,.82-3.18A5.1,5.1,0,0,1,99.21,336.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "97.4074px 339.375px"
    },
    id: "el9ocz2chbodd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.45,327.83a4.35,4.35,0,0,1-2.29,5.63,4.33,4.33,0,0,1,2.29-5.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.302px 330.645px"
    },
    id: "elfzdysxoaiz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.82,325.45a4.32,4.32,0,0,1,2.07,5.72,4.35,4.35,0,0,1-2.07-5.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "85.8598px 328.31px"
    },
    id: "eldeat9wh7cgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,336.34a4.33,4.33,0,0,1-.35,6.07,4.33,4.33,0,0,1,.35-6.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.535px 339.375px"
    },
    id: "elc8wikqkjtio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,320.13a4.35,4.35,0,0,1-.35,6.07A5.07,5.07,0,0,1,89,323.09,5.12,5.12,0,0,1,90.4,320.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.2344px 323.165px"
    },
    id: "ele3b4ms68u9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.18,354.71a4.33,4.33,0,0,0,3.63,4.87A5.09,5.09,0,0,0,80,356.4,5.15,5.15,0,0,0,77.18,354.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "78.9827px 357.145px"
    },
    id: "el3ya70l39my6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75,364.68a4.35,4.35,0,0,0,3.64,4.88,4.35,4.35,0,0,0-3.64-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "75.57px 367.12px"
    },
    id: "el1jljk54drlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.86,368.31a5.05,5.05,0,0,0,.82,3.18,5.1,5.1,0,0,0,2.81,1.69,5.13,5.13,0,0,0-.82-3.18A5,5,0,0,0,82.86,368.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "84.6741px 370.745px"
    },
    id: "elxpvsynhjgzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,354.48a4.33,4.33,0,0,0,2.08,5.71,4.33,4.33,0,0,0-2.08-5.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.39px 357.335px"
    },
    id: "elsyo4xl1fadb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,391.27a4.35,4.35,0,0,0,4.56-4,4.33,4.33,0,0,0-4.56,4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "81.18px 389.27px"
    },
    id: "el7yak3qovd1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,389.25a4.31,4.31,0,0,0,5.16,3.2,4.34,4.34,0,0,0-5.16-3.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "99.17px 390.853px"
    },
    id: "elvtbfymjabag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,345.51a4.33,4.33,0,0,0,3.63,4.88A4.35,4.35,0,0,0,81,345.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "82.8138px 347.95px"
    },
    id: "el4dp229txqxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.93,337.41a5.09,5.09,0,0,0,.81,3.18,5.15,5.15,0,0,0,2.82,1.69,5.13,5.13,0,0,0-.82-3.18A5,5,0,0,0,80.93,337.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "82.744px 339.845px"
    },
    id: "el8jpfqgees2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.41,376.83c0,15.11-8.94,27.36-20,27.36s-20-12.25-20-27.36,8.94-67,20-67S433.41,361.72,433.41,376.83Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "413.41px 357.01px"
    },
    id: "elvdj1gmvfyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.64 384.74 418.59 386.97 419.81 383.33 416.92 387.59 414.03 388.66 413.82 376.71 424.33 362.76 418.7 368.39 419.65 364.47 416.96 370.13 413.77 373.32 413.44 354.65 412.3 381.88 402.35 371.33 407.81 378.76 402.66 378.19 409.03 380.41 412.18 384.7 411.63 397.83 407.96 395.34 411.52 400.54 409.83 440.67 414.93 440.67 414.06 390.57 424.64 384.74",
    id: "elykxv6kn1p9f",
    className: "animable",
    style: {
      transformOrigin: "413.495px 397.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43,354.71a4.33,4.33,0,0,1-3.63,4.87,5.09,5.09,0,0,1,.81-3.18A5.15,5.15,0,0,1,424.43,354.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "422.627px 357.145px"
    },
    id: "eldyrajx9ocxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.44,363.16a5.07,5.07,0,0,1-.81,3.18,5.13,5.13,0,0,1-2.82,1.7,4.35,4.35,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "428.613px 365.6px"
    },
    id: "elsel6mcw4ltg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.44,379.62a4.34,4.34,0,0,1-5.06,3.37,4.34,4.34,0,0,1,5.06-3.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.91px 381.305px"
    },
    id: "el4row9wt40cu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,379.62a4.34,4.34,0,0,0,5.06,3.37,4.34,4.34,0,0,0-5.06-3.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "399.93px 381.305px"
    },
    id: "elny1pj4apqb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49,372.79a4.35,4.35,0,0,1-3.63,4.88,4.33,4.33,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "421.674px 375.23px"
    },
    id: "el4ko3fogp355",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.93,345.51a4.33,4.33,0,0,1-3.63,4.88,4.35,4.35,0,0,1,3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.116px 347.95px"
    },
    id: "el5gwdy4zy2rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.35,352.53a4.33,4.33,0,0,1-3.63,4.87,4.33,4.33,0,0,1,3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "416.535px 354.965px"
    },
    id: "ely36ce044izi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.86,347.42a5.13,5.13,0,0,1-.82,3.18,5,5,0,0,1-2.81,1.69,5.05,5.05,0,0,1,.82-3.18A5.1,5.1,0,0,1,426.86,347.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "425.044px 349.855px"
    },
    id: "el3eqiyueiyjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.2,347.42a5.13,5.13,0,0,0,.82,3.18,5,5,0,0,0,2.81,1.69,5.05,5.05,0,0,0-.82-3.18A5.1,5.1,0,0,0,399.2,347.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "401.016px 349.855px"
    },
    id: "el94ndbumia5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,336.94a5.05,5.05,0,0,1-.82,3.18,5.1,5.1,0,0,1-2.81,1.69,4.33,4.33,0,0,1,3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.883px 339.375px"
    },
    id: "elw73l1aakrt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,327.83a4.33,4.33,0,0,1-2.29,5.63,4.33,4.33,0,0,1,2.29-5.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "419.855px 330.645px"
    },
    id: "ello1nnwfjo4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.33,325.45a4.35,4.35,0,0,1,2.07,5.72,5.15,5.15,0,0,1-2.21-2.44A5.08,5.08,0,0,1,408.33,325.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "409.387px 328.31px"
    },
    id: "elh6uhsfzw7o9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,336.34a5.07,5.07,0,0,1,1.07,3.11,5.12,5.12,0,0,1-1.42,3,4.35,4.35,0,0,1,.35-6.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "414.036px 339.395px"
    },
    id: "elwwpgj0f17xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.9,320.13a4.33,4.33,0,0,1-.35,6.07,4.35,4.35,0,0,1,.35-6.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "413.729px 323.165px"
    },
    id: "eldt5v3tnqz7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.69,354.71a5.05,5.05,0,0,0,.82,3.18,5.1,5.1,0,0,0,2.81,1.69,4.33,4.33,0,0,0-3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "402.517px 357.145px"
    },
    id: "el1t2blz6x4do",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,364.68a4.35,4.35,0,0,0,3.63,4.88,4.35,4.35,0,0,0-3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "399.075px 367.12px"
    },
    id: "eluigtlpl437o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,368.31a4.33,4.33,0,0,0,3.63,4.87,4.33,4.33,0,0,0-3.63-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.175px 370.745px"
    },
    id: "elf4uy6pqhlon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.85,354.48a4.33,4.33,0,0,0,2.08,5.71,5,5,0,0,0,.13-3.28A5.11,5.11,0,0,0,408.85,354.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "409.867px 357.335px"
    },
    id: "ellw3vmqdtg3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4,391.27a4.35,4.35,0,0,0,4.57-4,4.33,4.33,0,0,0-4.57,4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "404.685px 389.269px"
    },
    id: "ellf1xr3it1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.09,389.25a4.33,4.33,0,0,0,5.17,3.2,4.35,4.35,0,0,0-5.17-3.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "422.675px 390.852px"
    },
    id: "elcilb43qh9cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.46,345.51a4.35,4.35,0,0,0,3.63,4.88,4.35,4.35,0,0,0-3.63-4.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "406.275px 347.95px"
    },
    id: "elwemzqmgo0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.43,337.41a5.05,5.05,0,0,0,.82,3.18,5.1,5.1,0,0,0,2.81,1.69,5.13,5.13,0,0,0-.82-3.18A5,5,0,0,0,404.43,337.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "406.244px 339.845px"
    },
    id: "elalcntn3glr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.18,391.54c0,11.63-6.88,21-15.36,21s-15.37-9.42-15.37-21S437.33,340,445.82,340,461.18,379.91,461.18,391.54Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "445.815px 376.27px"
    },
    id: "elpy0mp2si94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.43 397.62 449.78 399.34 450.71 396.54 448.49 399.82 446.27 400.64 446.11 391.45 454.19 380.71 449.86 385.04 450.59 382.03 448.52 386.38 446.06 388.83 445.82 374.47 444.94 395.42 437.28 387.31 441.48 393.02 437.52 392.58 442.42 394.29 444.84 397.59 444.42 407.7 441.6 405.78 444.33 409.79 443.03 440.67 446.96 440.67 446.29 402.11 454.43 397.62",
    id: "elt46wm9x4za",
    className: "animable",
    style: {
      transformOrigin: "445.855px 407.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27,374.51a3.35,3.35,0,0,1-2.8,3.76,3.35,3.35,0,0,1,2.8-3.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "452.87px 376.39px"
    },
    id: "els3x1hj2wvrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.9,381a3.33,3.33,0,0,1-2.8,3.75,3.33,3.33,0,0,1,2.8-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "457.5px 382.875px"
    },
    id: "elz8fxphlzgum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.9,393.69a3.35,3.35,0,0,1-3.9,2.59,3.35,3.35,0,0,1,3.9-2.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "456.95px 394.985px"
    },
    id: "el4uccv7diykl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,393.69a4,4,0,0,0,1.42,2.09,3.9,3.9,0,0,0,2.48.5,3.35,3.35,0,0,0-3.9-2.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.41px 394.972px"
    },
    id: "el5fes1ah422o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.55,388.43a3.33,3.33,0,0,1-2.8,3.75,3.33,3.33,0,0,1,2.8-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "452.15px 390.305px"
    },
    id: "elx06p6watdho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.35,367.44a3.34,3.34,0,0,1-2.8,3.75,3.33,3.33,0,0,1,2.8-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.949px 369.315px"
    },
    id: "ele8by803neqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.59,372.83a3.35,3.35,0,0,1-2.79,3.76,3.86,3.86,0,0,1,.63-2.45A3.91,3.91,0,0,1,449.59,372.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "448.204px 374.71px"
    },
    id: "elx11247xl8eb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.14,368.9a3.35,3.35,0,0,1-2.79,3.76,3.86,3.86,0,0,1,.63-2.45A3.91,3.91,0,0,1,456.14,368.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "454.754px 370.78px"
    },
    id: "eluk9cy5xlh4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,368.9a3.35,3.35,0,0,0,2.8,3.76,3.35,3.35,0,0,0-2.8-3.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "436.25px 370.78px"
    },
    id: "eln96tv0wiaqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,360.84a3.34,3.34,0,0,1-2.8,3.75,3.33,3.33,0,0,1,2.8-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "451.599px 362.715px"
    },
    id: "eluiuyri5s86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.59,353.83a3.32,3.32,0,0,1-1.76,4.33,3.35,3.35,0,0,1,1.76-4.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.714px 355.995px"
    },
    id: "elaol0f1h47dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.88,352a3.35,3.35,0,0,1,1.59,4.4,4,4,0,0,1-1.7-1.88A3.89,3.89,0,0,1,441.88,352Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "442.691px 354.2px"
    },
    id: "elobku73v0dqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.41,360.38a3.34,3.34,0,0,1-.27,4.67,3.34,3.34,0,0,1,.27-4.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "446.275px 362.715px"
    },
    id: "ele7yjnb8n93",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.17,347.9a3.34,3.34,0,0,1-.27,4.67,3.34,3.34,0,0,1,.27-4.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "446.035px 350.235px"
    },
    id: "eluhd0nor90d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,374.51a3.35,3.35,0,0,0,2.79,3.76,3.86,3.86,0,0,0-.63-2.45A3.91,3.91,0,0,0,436,374.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "437.386px 376.39px"
    },
    id: "elxg23vaid6m9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,382.19a3.33,3.33,0,0,0,2.79,3.75,3.84,3.84,0,0,0-.63-2.44A3.91,3.91,0,0,0,433.36,382.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "434.745px 384.065px"
    },
    id: "elrt9ors3597",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,385a3.9,3.9,0,0,0,.62,2.45,4,4,0,0,0,2.17,1.3,3.33,3.33,0,0,0-2.79-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "441.774px 386.875px"
    },
    id: "el4eq6nqo3gx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.28,374.34a3.94,3.94,0,0,0-.1,2.53,4,4,0,0,0,1.7,1.87,3.34,3.34,0,0,0-1.6-4.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "443.1px 376.54px"
    },
    id: "elt0ovo5h19w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.32,402.65a4,4,0,0,0,2.39-.83,3.89,3.89,0,0,0,1.12-2.26,3.32,3.32,0,0,0-3.51,3.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "439.075px 401.102px"
    },
    id: "elpsvy278kf39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.93,401.1a3.34,3.34,0,0,0,4,2.46,3.35,3.35,0,0,0-4-2.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "452.93px 402.331px"
    },
    id: "el0waspo8luul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.9,367.44a3.34,3.34,0,0,0,2.8,3.75,4,4,0,0,0-.63-2.45A3.88,3.88,0,0,0,438.9,367.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "440.29px 369.315px"
    },
    id: "el47mjdd2szqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,361.2a3.35,3.35,0,0,0,2.79,3.75,3.33,3.33,0,0,0-2.79-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "440.276px 363.075px"
    },
    id: "el8j0de9opsg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,391.54c0,11.63-6.88,21-15.36,21s-15.37-9.42-15.37-21S223.6,340,232.09,340,247.45,379.91,247.45,391.54Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "232.085px 376.27px"
    },
    id: "elkwcxhivnd1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.7 397.62 236.05 399.34 236.98 396.54 234.76 399.82 232.54 400.64 232.38 391.45 240.46 380.71 236.13 385.04 236.86 382.03 234.79 386.38 232.33 388.83 232.09 374.47 231.21 395.42 223.55 387.31 227.75 393.02 223.79 392.58 228.69 394.29 231.12 397.59 230.69 407.7 227.87 405.78 230.6 409.79 229.31 440.67 233.23 440.67 232.56 402.11 240.7 397.62",
    id: "elb6j3rryl07h",
    className: "animable",
    style: {
      transformOrigin: "232.125px 407.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,374.51a3.35,3.35,0,0,1-2.79,3.76,3.89,3.89,0,0,1,.62-2.45A4,4,0,0,1,240.54,374.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "239.154px 376.39px"
    },
    id: "elckpjn1xzaug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,381a3.33,3.33,0,0,1-2.79,3.75,3.87,3.87,0,0,1,.63-2.45A3.93,3.93,0,0,1,245.17,381Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.785px 382.875px"
    },
    id: "elrxiud513j77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,393.69a3.35,3.35,0,0,1-3.9,2.59,4,4,0,0,1,1.42-2.09A3.9,3.9,0,0,1,245.17,393.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.22px 394.998px"
    },
    id: "elvt7tw87125",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74,393.69a3.33,3.33,0,0,0,3.89,2.59,3.34,3.34,0,0,0-3.89-2.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.685px 394.986px"
    },
    id: "eldyoyuvh4js",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.82,388.43a3.33,3.33,0,0,1-2.79,3.75,3.9,3.9,0,0,1,.62-2.45A4,4,0,0,1,239.82,388.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "238.434px 390.305px"
    },
    id: "elbi71lrkownj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,367.44a3.35,3.35,0,0,1-2.79,3.75,3.33,3.33,0,0,1,2.79-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237.224px 369.315px"
    },
    id: "elyy1lodr0svc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,372.83a3.35,3.35,0,0,1-2.79,3.76,3.86,3.86,0,0,1,.63-2.45A3.91,3.91,0,0,1,235.86,372.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "234.474px 374.71px"
    },
    id: "elhyu1gp9qqhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,368.9a3.35,3.35,0,0,1-2.79,3.76,3.86,3.86,0,0,1,.63-2.45A3.91,3.91,0,0,1,242.41,368.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "241.024px 370.78px"
    },
    id: "elajmansrnr8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.13,368.9a3.87,3.87,0,0,0,.63,2.45,3.91,3.91,0,0,0,2.16,1.31,3.35,3.35,0,0,0-2.79-3.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.534px 370.78px"
    },
    id: "el8mzwllvlyu2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,360.84a3.35,3.35,0,0,1-2.79,3.75,3.9,3.9,0,0,1,.62-2.45A4,4,0,0,1,239.22,360.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237.833px 362.715px"
    },
    id: "elgv6hxln3nmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.86,353.83a3.89,3.89,0,0,1,0,2.53,4,4,0,0,1-1.77,1.8,3.35,3.35,0,0,1,1.76-4.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "236.957px 355.995px"
    },
    id: "elp6uv69s51ws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,352a3.93,3.93,0,0,1,1.69,1.87,3.88,3.88,0,0,1-.1,2.53,3.35,3.35,0,0,1-1.59-4.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "228.928px 354.2px"
    },
    id: "ell4sqy16ez4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,360.38a4,4,0,0,1,.82,2.39,3.89,3.89,0,0,1-1.09,2.28,3.34,3.34,0,0,1,.27-4.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "232.543px 362.715px"
    },
    id: "elrsxigqcl1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,347.9a4,4,0,0,1,.82,2.39,3.89,3.89,0,0,1-1.09,2.28,3.34,3.34,0,0,1,.27-4.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "232.303px 350.235px"
    },
    id: "elqs57wj5c67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,374.51a3.35,3.35,0,0,0,2.79,3.76,3.86,3.86,0,0,0-.63-2.45A3.91,3.91,0,0,0,222.27,374.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "223.656px 376.39px"
    },
    id: "elbitoe6195b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.63,382.19a3.33,3.33,0,0,0,2.79,3.75,3.87,3.87,0,0,0-.62-2.44A4,4,0,0,0,219.63,382.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.016px 384.065px"
    },
    id: "el7wkij5xnhyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.64,385a3.87,3.87,0,0,0,.63,2.45,3.93,3.93,0,0,0,2.16,1.3,3.33,3.33,0,0,0-2.79-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "228.045px 386.875px"
    },
    id: "eljrkb3c0bc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55,374.34a3.94,3.94,0,0,0-.1,2.53,4,4,0,0,0,1.7,1.87,3.34,3.34,0,0,0-1.6-4.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "229.37px 376.54px"
    },
    id: "elnwu64vim5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,402.65a4,4,0,0,0,2.39-.83,3.89,3.89,0,0,0,1.12-2.26,3.32,3.32,0,0,0-3.51,3.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "225.345px 401.102px"
    },
    id: "elk9pgkr4f4xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,401.1a3.35,3.35,0,0,0,4,2.46,3.35,3.35,0,0,0-4-2.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "239.2px 402.33px"
    },
    id: "elriopb4ne5uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,367.44a3.34,3.34,0,0,0,2.8,3.75,4,4,0,0,0-.63-2.45A3.88,3.88,0,0,0,225.17,367.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "226.56px 369.315px"
    },
    id: "eljye6o5aqq9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,361.2a3.35,3.35,0,0,0,2.79,3.75,3.87,3.87,0,0,0-.63-2.45A3.93,3.93,0,0,0,225.15,361.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "226.537px 363.075px"
    },
    id: "elfstxbpkuujb",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgImage);
export default __webpack_public_path__ + "static/media/OrgImage.bcac01b03017a5657413f33cce7cfdba.svg";
export { ForwardRef as ReactComponent };